export default {
  "general": {
    "no_results": "No results",
    "active": "Active",
    "and": "and",
    "display_name_and_email": "{displayName} ({email})",
    "are_you_sure_continue": "Are you sure you wish to continue?",
    "nevermind": "Nevermind",
    "in": "in",
    "no_thanks": "No thanks",
    "go_to_login": "Go to login",
    "loading_results": "Loading results",
    "inactive": "Inactive",
    "back": "Back",
    "clear": "Clear",
    "close": "Close",
    "action_cannot_be_undone": "This action cannot be undone",
    "now": "Now",
    "min_characters": "{current} characters (min {min} characters)",
    "max_characters": "{current} characters (max {max} characters)",
    "deleted": "Deleted",
    "display_name": "{displayName} | {displayName} (You)",
    "something_went_wrong": "Something went wrong..",
    "take_me_home": "Take me home",
    "whitespace-nowrap": "Under review",
    "save": "Save",
    "yes_delete": "Yes, delete",
    "okay": "Okay",
    "would_like_to_invite_you_to_organisation": "would like to invite you to join the organization",
    "required": "Required",
    "yes_action": "Yes, {action}",
    "desktop_app_warning": {
      "message": "You're opening the mobile version of Batchflow on a desktop. For the full toolkit and the best experience, switch to the desktop version.",
      "title": "Better on desktop"
    },
    "or": "or",
    "of": "of",
    "description": "Description",
    "yes_delete_template": "Yes, delete template",
    "name": "Name",
    "creditor": "Creditor",
    "forward": "Forward"
  },
  "activitylog": {
    "action": {
      "field_changed_from": "from",
      "flow_updated_replaced": "Replaced themselves with {user} as an approver in the flow",
      "export_failed_with_message": "Export failed with message",
      "flow_cancelled": "Cancelled the current {flowtype}: {flowname}",
      "document_return_to": "Document returned to",
      "field_changed": "Changed",
      "flow_updated_add_approver_after": "Added {user} as an approver after themselves in the flow",
      "field_added": "Added",
      "imported": "Imported",
      "flow_updated_added": "Added {user} as an approver before themselves in the flow",
      "flow_was_cancelled": "Flow cancelled",
      "category": "Category",
      "flow_participant_inserted": "Added {targetUser} as an approver in the flow",
      "deleted_by": "Deleted by",
      "changed_approvers": "Changed the approvers",
      "field_changed_to": "to",
      "required_declines": "Required declines:",
      "item_deleted": "Deleted",
      "required_approvals": "Required approvals:",
      "voucher_number": "Voucher number",
      "workstatus_to": "To",
      "item_added": "Document created",
      "item_exportet": "Exported",
      "workstatus_from": "From",
      "reason": "Reason",
      "updated": "Updated",
      "document_merge_to": "Document has been attached to another document",
      "document_merge": "A document has been attached to this document",
      "document_merge_attached": "Attachments",
      "document_merge_second_line": "See the document and its attachments under"
    },
    "empty_value": "None",
    "groups": {
      "document_rejectedby": "Document declined on behalf of {owner}",
      "document_approvedby": "Document approved on behalf of {owner}",
      "bulk_create_projects_integration": "Imported projects",
      "bulk_update_cost_types": "Updated cost types",
      "attachment_added": "Attachment added",
      "document_approved": "Document approved",
      "bulk_create_cost_types_integration": "Imported cost types",
      "comment_added": "Added a comment",
      "bulk_create_cost_types": "Created cost types",
      "bulk_update_projects": "Updated projects",
      "bulk_create_employees_integration": "Imported owners",
      "bulk_create_projects": "Created projects",
      "document_rejected": "Document rejected",
      "document_approved_description": "{approver} was acting as delegate for {owner} due to being out of office",
      "attachment_deleted": "Attachment deleted",
      "item_return_to_declined": "Document returned to Declined",
      "journal_line_deleted": "Deleted journal entry",
      "item_export_succeded": "Document was exported",
      "flow_item_sent_to_user": "Sent to user",
      "item_export_ready": "Ready for export",
      "item_saved": "Document saved",
      "item_emailed": "Document emailed",
      "flow_item_received": "Document received",
      "flow_updated": "Updated flow",
      "item_deleted": "Document deleted",
      "item_put_on_hold": "Document put on hold",
      "item_return_from_archived": "Document returned from Archived",
      "item_return_to_new_documents": "Document return to new document",
      "flow_deleted": "Deleted the {flowtype}: {flowname}",
      "item_export_failed": "Document couldn't be exported",
      "item_returned_from_hold": "Returned from On hold",
      "item_added": "Document received",
      "item_reject_note": "Added a decline note",
      "item_return_from_delete": "Document returned form Deleted",
      "journal_line_added": "Added journal entry",
      "item_marked_as_unique": "Marked as unique",
      "document_rejected_description": "{approver} declined the document on behalf of {owner} due to being out of office",
      "item_moved_to_archive": "Document moved to Archived",
      "item_return_to_archived": "Document returned to Archived",
      "item_ready_for_export": "Document ready for export",
      "item_ready_for_re_export": "Document ready for re-export",
      "journal_line_modified": "Modified journal entry",
      "item_flow_assigned": "Applied the {flowtype}: {flowname}",
      "item_deleted_as_duplicate": "Document deleted",
      "fields_modified": "Modified fields",
      "document_saved_locally": "Document download",
      "item_printed": "Document printet",
      "flow_created": "Added the {flowtype}: {flowname}",
      "item_return_to_export_errors": "Document returned to Export errors",
      "modified_employees": "Updated owner links",
      "user_out_of_office": "User is Out Of Office",
      "voucher_imported": "Voucher number imported",
      "system": "System",
      "reason_category_changed": "Modified archive category",
      "sent_review": "Sent for review",
      "replaced_in_flow": "Replaced in flow",
      "user_company_disable": "{flowtype} updated: {flowname}",
      "user_removed_from_flow": "Removed from flow",
      "item_move_to_another_company": "Document moved from another company",
      "flow_item_auto_declined": "Document declined automatically",
      "final_approval_by_limit": "{approver} had a sufficient approval limit to approve the document",
      "final_approval_by_required": "The document was fully approved because {accepted} of {required} required approvals were received",
      "document_attached": "Document attached",
      "journal_template_applied": "Journal entry template applied",
      "calculated_due_date_applied": "Calculated due date has been applied",
      "previous_approval": "Previous approval: {date}",
      "document_automatically_approved_description": "{approver} had previously approved this document.",
      "automatic_approval_controls": "Approval was completed automatically based on company approval controls",
      "document_automatically_approved": "Document automatically approved"
    },
    "automation": {
      "began_automation": "Began automation: {automation}"
    },
    "automations": {
      "accounting_line": "Accounting Line"
    },
    "employees": {
      "linked": "Linked",
      "to": "To",
      "unlinked": "Unlinked",
      "from": "From"
    },
    "duplicate": {
      "item_marked_as_unique": "Document is not a duplicate",
      "item_deleted_as_duplicate": "Marked as duplicate"
    },
    "description": {
      "document_rejected_description": "{approver} declined the document on behalf of {owner} due to being out of office",
      "document_approved_description": "{approver} was acting as delegate for {owner} due to being out of office"
    },
    "automation_block": {
      "added_accounting_lines": "Added {count} accounting lines",
      "deleted_accounting_lines": "Deleted {count} accounting lines"
    },
    "return_from_onhold": {
      "to_widget": "Document returned to {widget}",
      "to_assignee": "Document returned to assignee | Document returned to assignees"
    },
    "onhold": {
      "reason": "Reason",
      "additional_note": "Additional note"
    }
  },
  "accounting": {
    "popular_vatgroups": "Recently used VAT",
    "fields": {
      "postingtext": "Posting text",
      "vatcode": "VAT code",
      "amount": "Amount",
      "accountno": "Account",
      "contraaccount": "Contra account",
      "accountname": "Account name",
      "accountnumber": "Account",
      "contraaccountnumber": "Contra account"
    },
    "popular_accounts": "Recently used accounts",
    "popular_dimension_list": "Recently used {column}",
    "add_new_entry": "Add a new entry",
    "browse": {
      "title": "Templates",
      "empty_description": "Create a template to reuse on future journal entries.",
      "favorites": "Favorites",
      "apply_template": "Apply template",
      "starting_point_hint": "This template is a starting point. You can review and edit after it’s applied.",
      "filter_templates": "Filter templates",
      "empty_title": "No templates have been added yet",
      "all": "All",
      "templates": "Browse templates",
      "search_placeholder": "Search for templates",
      "empty_search_description": "Check spelling or try another search",
      "empty_search_title": "We couldn't find the template you were looking for"
    },
    "save": {
      "template_name_required": "Please provide a template name",
      "template_name": "Template name",
      "title": "Save as template",
      "overwrite_existing_subtitle": "Overwrite existing template from current journal entries",
      "overwrite_warning_subtitle": "The overwrite will update journal entries, description, icon and amount fields",
      "overwrite_template": "Overwrite template",
      "save_as": "Save as",
      "overwrite_warning_title": "This will overwrite the selected template",
      "save_template": "Save template",
      "description": "Description (optional)",
      "overwrite_existing": "Overwrite existing",
      "template_to_overwrite_required": "Please select a template to overwrite",
      "new_template_subtitle": "Create a new template from current journal entries",
      "template_name_placeholder": "Please provide a template name",
      "description_placeholder": "Describe when to use this template",
      "new_template": "New template",
      "template_to_overwrite": "Template to overwrite"
    },
    "template": {
      "save_as_tooltip": "Save as template",
      "already_exists": "A template with this name already exists.",
      "add_accounting_line": "Add at least one entry to save",
      "applied": "Template applied",
      "link_removed": "Template link removed"
    },
    "delete_entry": "Delete entry"
  },
  "action": {
    "flow_was_cancelled": "Flow cancelled"
  },
  "admin-activitylog": {
    "groups": {
      "miscellaneous": "Miscellaneous settings",
      "miscellaneous_mandatory_onhold_additional_note": "Changed miscellaneous settings",
      "role_change_setting": "Edited {role} role",
      "role_change": "Edited {role} role",
      "user_2fa_enable": "Two-factor authentication was setup",
      "user_invite_accepted": "Invitation was accepted",
      "automation_deleted": "Deleted automation {automation}",
      "authentication_mandatory_two_factor": "Changed security settings",
      "user_company_disable": "Deactivated user {user}",
      "user_change_password_request": "Requested password reset for {user}",
      "automation_added": "Added automation {automation}",
      "security": "Security settings",
      "user_invite": "Invited new user",
      "user_2fa_disable": "Two-factor authentication was removed",
      "user_avatar_updated": "Changed avatar",
      "automation_updated": "Updated automation {automation}",
      "automation_status_updated": "Updated automation {automation}",
      "user_invite_revoked": "Invitation was revoked",
      "widget_changed": "Widget changes made to {widget}",
      "user_password_changed": "Updated their password",
      "user_update_workstatus": "Changed work status for {user}",
      "user_role_change": "Changed role for {user}",
      "user_update_info": "Updated user information",
      "user_invite_resend": "Resend invitation user invitation"
    },
    "unknown_company": "Unknown company",
    "approval_limits": {
      "changed_document_type": "Changed {documentType} approval limit",
      "group_changed": "Changed approval limit for {user} in {company}",
      "unlimited": "Unlimited",
      "unknown_user": "Unknown user"
    },
    "flows": {
      "changed_flow_users": "Changed users in flow"
    },
    "user_remove": {
      "replace_by": "Replaced by",
      "changeinfo": "{user} in {company}"
    },
    "user_change_role": {
      "to_role": "To {role}",
      "from_role": "From {role}"
    },
    "role": {
      "widget_changed": "Changed widget visibility for {widget}",
      "setting_changed": "Changed {setting}"
    },
    "widget": {
      "permissions": "Changed widget settings",
      "deactivated": "Widget was deactivated",
      "key_metrics": "Changed key metrics",
      "activated": "Widget was activated",
      "action_changed_view": "Changed view rights to {action}",
      "actions": "Changed actions",
      "metric_changed_view": "Changed view rights to {metric}"
    },
    "user_invite": {
      "accepted": "Invitation to {email} was accepted",
      "company_role_info": "{company} as {role}",
      "resend_to": "Invitation sent to {email}",
      "company_include": "Companies include",
      "sent_to": "Invitation sent to {email}",
      "revoked_from": "Invitation to {email} was revoked",
      "language": "Invited with language {language}"
    },
    "user_change_password_request": {
      "details": "Request sent to {email}"
    },
    "user": {
      "workstatus_changed_timeframe": "Timeframe",
      "workstatus_changed": "Changed work status",
      "workstatus_delegate_in_company": "Delegate in {company} is set to {user}"
    },
    "user_role_change": {
      "company_info": "Changed role in {company}"
    }
  },
  "automations": {
    "buttons": {
      "yes_save_changes": "Yes, save changes",
      "apply_check": "Apply check",
      "add_check": "Add check",
      "yes_delete_automation": "Yes, delete automation",
      "apply_creditor_check": "Apply creditor check",
      "add_action": "Add action",
      "save_and_activate": "Save and activate",
      "add_component": "Add {component}",
      "revert_changes": "Revert changes",
      "saving_automation": "Saving automation",
      "automation_order": "Automation order",
      "apply_journal_entry": "Apply journal entries",
      "save_automation": "Save automation",
      "update_automation": "Update automation",
      "remove_component": "Remove component",
      "delete_automation": "Delete automation",
      "go_back": "Go back",
      "create_new_automation": "Create new automation",
      "add_loop": "Add loop",
      "apply_event_type": "Apply event",
      "apply_send_action": "Apply action",
      "add_step": "Add step",
      "delete_check": "Delete check",
      "add_loop_check": "Add loop check",
      "add_loop_action": "Add loop action",
      "add_loop_step": "Add loop step",
      "delete_loop": "Delete loop",
      "delete_action": "Delete action"
    },
    "actions": {
      "add_an_action": "Add an action to the automation",
      "actions": "Actions",
      "action": "action",
      "undo": "Undo",
      "search_for_an_action": "Search for an action",
      "delete": "Delete automation",
      "edit": "Edit name and description",
      "test_automation": "Test Automation",
      "redo": "Redo",
      "no_search_results": "We couldn't find the action you were looking for",
      "unknown_action_type": "Unknown action type",
      "settings": "Automation settings"
    },
    "action": {
      "title": "Action: {action}"
    },
    "apply_most_recent_journal_entries": {
      "add_remainder_as_new_entry": "Add remainder as new entry line",
      "insert_creditor_name": "Insert creditor name",
      "select_posting_text_option": "Please select a posting text option",
      "title": "Apply most recent journal entries",
      "copy_posting_text": "Copy posting text",
      "copy_posting_text_description": "Copy the exact posting text for each entry line",
      "blank_description": "Do not insert anything",
      "posting_text": "Posting text",
      "amount": "Amount",
      "blank": "Blank",
      "select_amount_option": "Please select an amount option",
      "distribute_evenly": "Divide evenly across entry lines",
      "add_full_amount_to_first_entry": "Add amount to the first entry line",
      "add_remainder_to_first_entry": "Add remainder to first entry line",
      "accounting_lines": "Journal entries",
      "add_full_amount_to_first_entry_description": "Add the full amount to the first journal entry line and leave all other lines at zero",
      "add_remainder_to_first_entry_description": "Keep the existing line amounts and add any remaining amount to the first line",
      "subtitle": "Apply the creditor’s most recent journal entries",
      "distribute_evenly_description": "Split the amount evenly across all journal entry lines. Any rounding difference is added to the first line",
      "add_remainder_as_new_entry_description": "Keep the existing line amounts and add any remaining amount as a new journal entry line",
      "insert_creditor_name_description": "Insert creditor name on each entry line"
    },
    "apply_most_used_flow": {
      "last_month_description": "Apply the most used flow from the past month",
      "last_6_months_description": "Apply the most used flow from the past 6 months",
      "assign": "assign flow",
      "last_3_months": "Last 3 months",
      "last_month": "Last month",
      "select_period_option": "Please select a date range",
      "last_3_months_description": "Apply the most used flow from the past 3 months",
      "the_period": "The {period}, {action}",
      "assign_and_send": "assign flow and send for review",
      "subtitle": "Apply most used flow by the creditor",
      "period": "Period",
      "title": "Apply most used flow",
      "last_6_months": "Last 6 months",
      "title_from": "Apply most used flow from:"
    },
    "apply_most_recent_flow": {
      "assign": "Assign most recent flow",
      "assign_and_send": "Assign most recent flow and send for review",
      "description_assign_and_send": "Apply most recent flow and assign and send for review",
      "subtitle": "Apply the most recent used flow by the creditor",
      "description_assign": "Apply most recent flow and assign",
      "title": "Apply most recent flow"
    },
    "apply_most_used_journal_entries": {
      "last_3_months_description": "Apply the most used journal entry combination from the past 3 months",
      "last_3_months": "Last 3 months",
      "last_6_months": "Last 6 months",
      "period": "Period",
      "last_6_months_description": "Apply the most used journal entry combination from the past 6 months",
      "subtitle": "Apply most used journal entries by the creditor",
      "last_month_description": "Apply the most used journal entry combination from the past month",
      "title": "Apply most used journal entries",
      "title_from": "Apply most used journal entry from:",
      "select_period_option": "Please select a date range",
      "last_month": "Last month",
      "the_period": "The {period}"
    },
    "checks": {
      "is_empty": "Is empty",
      "add_a_check": "Add a check to the automation",
      "choose_a_check_method": "Please choose a check method",
      "is_one_of": "Is one of",
      "equals": "Is",
      "is_not_empty": "Is not empty",
      "search_for_a_check": "Search for a check",
      "check_method": "Check method",
      "no_search_results": "We couldn't find the check you were looking for",
      "checks": "Checks",
      "is_not_one_of": "Is not one of",
      "check": "check",
      "not_equals": "Is not",
      "does_not_end_with": "Does not end with",
      "does_not_match_regex_description": "Checks if the field does not match a regular expression",
      "does_not_contain": "Does not contain",
      "greater_than_description": "Checks if the field is greater than the value",
      "does_not_start_with": "Does not start with",
      "not_equals_description": "Checks if the field does not exactly match the value",
      "equals_description": "Checks if the field exactly matches the value",
      "contains": "Contains",
      "does_not_start_with_description": "Checks if the field does not start with the value",
      "contains_similar": "Contains similar",
      "does_not_contain_similar": "Does not contain similar",
      "does_not_end_with_description": "Checks if the field does not end with the value",
      "is_not_one_of_description": "Checks if the field matches none of the selected values",
      "ends_with_description": "Checks if the field ends with the value",
      "less_than": "Is less than",
      "does_not_contain_description": "Checks if the field does not contain the value",
      "does_not_match_regex": "Does not match regex",
      "less_than_or_equal_to_description": "Checks if the field is less than or equal to the value",
      "greater_than_or_equal_to": "Is greater than or equal to",
      "is_one_of_description": "Checks if the field matches any selected value",
      "is_empty_description": "Checks if the field has no value",
      "less_than_description": "Checks if the field is less than the value",
      "matches_regex": "Matches regex",
      "is_not_empty_description": "Checks if the field has a value",
      "ends_with": "Ends with",
      "contains_description": "Checks if the field contains the value",
      "less_than_or_equal_to": "Is less than or equal to",
      "greater_than": "Is greater than",
      "matches_regex_description": "Checks if the field matches a regular expression",
      "greater_than_or_equal_to_description": "Checks if the field is greater than or equal to the value",
      "starts_with_description": "Checks if the field starts with the value",
      "starts_with": "Starts with"
    },
    "columns": {
      "event_type": "Event type",
      "name": "NAME",
      "status": "Status",
      "description": "Description",
      "stop_other_automations": "Auto stop"
    },
    "check": {
      "if": "If: {type} {condition}",
      "else_if": "Else if: {type} {condition}"
    },
    "block": {
      "add_a_component": "Add a component"
    },
    "fields": {
      "conditionstring": "Check method",
      "name": "Name",
      "eventtypestring": "Event type",
      "statusstring": "Status",
      "description": "Description"
    },
    "condition": {
      "title": "Condition: {condition}"
    },
    "creditor_check": {
      "choose_a_creditor": "Please choose a creditor",
      "creditors": "{count} creditors",
      "add_more_creditors": "Add more creditors",
      "additional_creditor": "Additional creditor | Additional creditors",
      "subtitle": "Check the creditor",
      "creditor": "Creditor",
      "title": "Creditor"
    },
    "send_to_flow": {
      "flow": "Flow",
      "select_a_flow": "Please select a flow",
      "assign_description": "Assign flow without sending for review",
      "assign_method": "Assign method",
      "assign": "Assign",
      "title": "Assign to flow",
      "assign_and_send": "Assign flow and send for review",
      "subtitle": "Send the document in a specific flow",
      "assign_and_send_description": "Assign and send the document to the users' inbox",
      "select_an_assign_method": "Please select assign method"
    },
    "empty": {
      "description": "Get started by creating automations to make Batchflow do the work",
      "header": "No automations have been created yet..."
    },
    "notifications": {
      "automation_was_not_saved": "Something went wrong..",
      "automation_was_updated": "Automation was updated",
      "deleted_automation_subtitle": "{automation} was successfully deleted and will not be run again",
      "automation_was_not_saved_subtitle": "{automation} couldn't be saved, please try again later",
      "automation_was_updated_subtitle": "{automation} was successfully updated",
      "deleted_automation": "Automation was deleted",
      "automation_was_saved": "Automation was saved",
      "automation_was_saved_subtitle": "{automation} was successfully saved"
    },
    "create_journal_entries": {
      "add_rest_amount_to_last_entry": "Add remainder to last entry line",
      "creditor_name": "Creditor name",
      "manual": "Manual input",
      "subtitle": "Create one or more journal entries",
      "add_rest_amount_to_last_entry_description": "Add remainder to the last entry line",
      "title": "Create journal entries",
      "rest_invoice_amount": "Remainder",
      "distribute_amount_evenly": "Distribute evenly",
      "full_invoice_amount": "Full invoice amount",
      "manual_description": "Enter the amount manually on each journal entry line",
      "add_full_amount_to_first_entry_description": "Add the full amount to the first journal entry line",
      "add_full_amount_to_first_entry": "Add full amount to first entry line",
      "template_linked": "Linked template: {name}",
      "template_missing": "The linked journal template is no longer available. Replace it or remove the link to configure journal entries.",
      "remove_template_link": "Remove template link",
      "template_load_failed": "The journal template could not be loaded."
    },
    "groups": {
      "journal-entries": "Journal entries",
      "document": "Document",
      "flow": "Flow",
      "amounts": "Amounts",
      "dates": "Dates",
      "payment-details": "Payment details",
      "loop-checks": "Line checks"
    },
    "order_modal": {
      "activate": "Activate",
      "move_to_bottom": "Move to bottom",
      "create_automations_to_order": "Once automations have been created, you'll be able to change the order in which they are executed.",
      "automation_could_not_be_activated_description": "The automation needs at least one action before activation is allowed.\nWould you like to navigate to the automation?",
      "move_to_top": "Move to top",
      "navigate_to_automation": "Go to automation",
      "search_for_automations": "Search for automation",
      "deactivate": "Deactivate",
      "automation_could_not_be_activated": "Automation couldn't be activated",
      "applying_order": "Applying order",
      "title": "Automation order",
      "no_automations": "No automations to order yet",
      "apply_order": "Apply order"
    },
    "components": {
      "add_component": "Add a component to your automation",
      "components": "Components"
    },
    "title": {
      "untitled_automation": "Untitled automation",
      "no_description_provided": "No description has been provided"
    },
    "event": {
      "document_received_title": "Document is received",
      "document-received": "Document received",
      "event_title": "Event",
      "event_subtitle": "Select which event type you wish to start from",
      "document_received_subtitle": "Runs when a document is received in Batchflow",
      "document-ready-for-export": "Document is ready for export",
      "document-final-approved": "Document is final approved",
      "item_put_on_hold_subtitle": "Runs when a document is put on hold",
      "document-approved": "Document is approved",
      "item_export_error_title": "Document has export errors",
      "item_ready_for_export_subtitle": "Runs when a document becomes ready for export",
      "item_declined_subtitle": "Runs when a document is finally rejected in the flow",
      "item_received_subtitle": "Runs when a new document is received in Batchflow",
      "document-export-error": "Document has an export error",
      "document-declined": "Document is declined",
      "document-exported": "Document is exported",
      "item_approved_title": "Document is approved",
      "item_ready_for_export_title": "Document is ready for export",
      "item_approved_subtitle": "Runs when a document is approved by a user",
      "item_sent_to_inbox_subtitle": "Runs when a document is sent for approval",
      "document-sent-to-inbox": "Document is sent to an Inbox",
      "item_sent_to_inbox_title": "Document is sent for approval",
      "item_received_title": "Document is received",
      "item_exported_subtitle": "Runs when a document export is completed",
      "item_export_error_subtitle": "Runs when an error occurs during export",
      "item_put_on_hold_title": "Document is put on hold",
      "item_final_approved_title": "Document fully approved",
      "item_final_approved_subtitle": "Runs when a document is fully approved in the flow",
      "item_exported_title": "Document is exported",
      "document-put-on-hold": "Document is put on hold",
      "item_declined_title": "Document is declined"
    },
    "events": {
      "no_search_results": "We couldn't find the event you were looking for",
      "event_title": "Events",
      "search_for_an_event": "Search for an event",
      "event_subtitle": "Select which event you wish to start from"
    },
    "loops": {
      "loop": "loop",
      "add_a_loop": "Add a loop",
      "loops": "Loops",
      "coming_soon": "Coming soon...",
      "for_each_description": "Runs child blocks once for each source line",
      "action_count": "{count} action | {count} actions",
      "accounting_lines": "Accounting lines",
      "empty_body": "No steps yet",
      "accounting_lines_description": "Once for every journal entry on the document",
      "for_each": "Loop over",
      "source": "Source",
      "collapse": "Collapse",
      "product_lines_description": "Once for every product line on the document",
      "show": "Show",
      "choose_source": "The steps you add will run once for each of these lines",
      "incompatible_fields": "The selected source does not support these fields: {fields}",
      "product_lines": "Product lines",
      "check_count": "{count} check | {count} checks"
    },
    "send_to_user": {
      "user": "User",
      "assign": "Assign",
      "assign_description": "Assign the user without sending for review",
      "assign_user_and_send_description": "Assign and send document to the user's inbox",
      "title": "Assign to user",
      "assign_method": "Assign method",
      "subtitle": "Send the document to a specific user",
      "choose_a_user": "Please select a user",
      "select_an_assign_method": "Please select assign method",
      "assign_user_and_send": "Assign user and send for review"
    },
    "tooltips": {
      "add_an_else": "Add an else"
    },
    "warnings": {
      "unsaved_changes_confirmation": "You have unsaved changes. If you leave now, they'll be lost.",
      "unsaved_changes": "Want to keep your changes?",
      "remove_entire_chain": "You are about to delete an entire section",
      "delete_automation_confirmation": "By deleting the automation, you will lose the current setup. The automation will be removed from the list and cannot be run again.",
      "remove_entire_chain_confirmation": "By removing '{component}' you'll be removing this and all nested components.",
      "remove_entire_chain_confirmation_subtext": "This action can be undone by clicking Undo",
      "delete_automation": "Are you sure you wish to delete the automation?"
    },
    "search": {
      "please_check_your_spelling": "Check your spelling or try another keyword"
    },
    "save_automation_modal": {
      "save_automation_title": "Save automation"
    },
    "status": {
      "inactive": "Inactive",
      "active": "Active",
      "deleted": "Deleted"
    },
    "save_automation_modals": {
      "save_automation_subtitle": "Set name and description of your automation"
    },
    "validation": {
      "activation_requirements": "Resolve the requirements before activating this automation.",
      "not_ready_to_activate": "Not ready to activate",
      "template_missing": "A linked journal template is missing. Repair the affected action before activating this automation.",
      "self_trigger_warning": "An action may trigger the automation again. Loop protection prevents repeated runs, but review the events and actions before enabling the automation."
    },
    "search_empty": {
      "header": "No matching automations",
      "description": "Try a different search to find automations."
    },
    "automation_order": "Automation order",
    "loop": {
      "title": "{loop}",
      "coming_soon": "Coming soon..."
    },
    "item_field_check": {
      "condition_not_available": "This check method is not available for the selected field.",
      "too_many_values": "Remove the extra values before applying this check.",
      "net_amount_title": "Net amount",
      "regex_invalid": "Enter a valid regular expression",
      "invoice_date_label": "Invoice date",
      "additional_field_subtitle": "Search company specific document fields",
      "currency_title": "Currency",
      "total_amount_title": "Total amount",
      "not_date_filter": "Not {filter}",
      "invoice_date_subtitle": "Check the invoice date",
      "payment_type_label": "Payment type",
      "amount_placeholder": "Enter amount",
      "total_amount_label": "Total amount",
      "invoice_number_placeholder": "Enter invoice number or pattern",
      "generic_title": "Item field check",
      "ocr_text_placeholder": "Enter text or wildcard",
      "value_not_available": "One or more selected values are not available for this field.",
      "invoice_number_subtitle": "Check the invoice number",
      "document_type_label": "Document type",
      "total_amount_subtitle": "Check the total amount",
      "vat_amount_label": "VAT amount",
      "due_date_title": "Due date",
      "invoice_number_label": "Invoice number",
      "regex_test_label": "Test value",
      "net_amount_label": "Net amount",
      "regex_test_placeholder": "Enter a value to test",
      "due_date_label": "Due date",
      "additional_field_label": "Additional field",
      "document_type_title": "Document type",
      "additional_field_value_label": "Additional field value",
      "document_type_subtitle": "Check the document type",
      "invoice_number_title": "Invoice number",
      "regex_no_matches": "No matches found",
      "add_more_values": "Add more values",
      "ocr_text_subtitle": "Check whether the document contains specific text",
      "payment_type_subtitle": "Check the payment type",
      "additional_field_placeholder": "Please choose an additional field",
      "net_amount_subtitle": "Check the net amount",
      "additional_field_title": "Additional fields",
      "payment_type_placeholder": "Please choose a payment type",
      "currency_label": "Currency",
      "date_placeholder": "YYYY-MM-DD",
      "invoice_date_title": "Invoice date",
      "duplicate_value": "The same value cannot be used more than once.",
      "currency_placeholder": "Please choose a currency",
      "regex_matches_found": "{count} match found | {count} matches found",
      "vat_amount_title": "VAT amount",
      "regex_empty_match": "Empty match",
      "document_type_placeholder": "Please choose a document type",
      "vat_amount_subtitle": "Check the VAT amount",
      "currency_subtitle": "Check the currency",
      "additional_field_value_placeholder": "Enter field value or wildcard",
      "payment_type_title": "Payment type",
      "due_date_subtitle": "Check the due date",
      "ocr_text_title": "Document text",
      "ocr_text_label": "Document text",
      "loop_field_subtitle": "Check a field on the current line",
      "discount_percentage_label": "Discount percentage",
      "line_price_label": "Line price",
      "quantity_label": "Quantity",
      "unit_price_subtitle": "Check the unit price",
      "date_on_or_after": "On or after",
      "date_on_or_before": "On or before",
      "unit_price_label": "Unit price",
      "line_amount_label": "Amount",
      "vat_code_label": "VAT code",
      "item_number_subtitle": "Check the item number",
      "item_number_label": "Item number",
      "vat_percentage_label": "VAT percentage",
      "description_label": "Description",
      "description_subtitle": "Check the description",
      "quantity_subtitle": "Check the quantity",
      "account_number_label": "Account number",
      "line_price_subtitle": "Check the line price",
      "date_before": "Before",
      "posting_text_label": "Posting text",
      "line_name_subtitle": "Check the line name",
      "date_after": "After",
      "loop_text_placeholder": "Enter a value",
      "line_name_label": "Line name",
      "discount_amount_label": "Discount amount",
      "vat_percentage_subtitle": "Check the VAT percentage"
    },
    "conditions": {
      "did_not_pass": "Condition did not pass",
      "passed": "Condition passed",
      "invalid_block": "The condition block was invalid"
    },
    "search_and_filter": "Search and filter for Name, Description or Event type",
    "settings_modal": {
      "stop_if_validation_fails": "Stop if validation fails",
      "stop_if_validation_fails_description": "If validation issues arise when this automation is run, it will stop running",
      "stop_other_automations_on_success": "Auto stop other automations",
      "title": "Automation settings",
      "subtitle": "Set specific settings for this automation",
      "stop_other_automations_on_success_description": "When this automation succeeds, later matching automations are skipped"
    },
    "variable_expression": {
      "validation_unmatched_bracket": "Unmatched bracket",
      "operator_multiply": "Multiply",
      "validation_two_operators": "Two operators in a row",
      "remove_formula": "Remove formula",
      "add_dynamic_text": "Add dynamic text",
      "overlay_heading": "Document variables",
      "validation_invalid_amount": "That isn't a valid formula",
      "operator_subtract": "Subtract",
      "text_placeholder": "Type text or use {'@'} to insert a variable",
      "validation_starts_with_operator": "A formula can't start with an operator",
      "formula_badge": "Formula",
      "validation_operator_after_open": "An operator can't follow an opening bracket",
      "dynamic_text_badge": "Dynamic text",
      "operator_add": "Add",
      "add_function": "Add a function",
      "operator_left_bracket": "Left bracket",
      "operators_category": "Operators",
      "empty_calculation": "Nothing added yet",
      "overlay_subtitle": "Choose a variable to add",
      "overlay_subtitle_operators": "Choose an operator for calculation",
      "operator_right_bracket": "Right bracket",
      "validation_divide_by_zero": "You can't divide by zero",
      "validation_ends_with_operator": "A formula can't end with an operator",
      "validation_missing_operator": "Missing operator between values",
      "operator_divide": "Divide",
      "full_view": "Full view",
      "overlay_subtitle_with_operators": "Choose a variable or operator to add",
      "overlay_search_empty": "Check spelling or try another search prompt",
      "calculation_help": "Type numbers, variables or operators",
      "validation_empty_text": "Add text or a variable first",
      "remove_dynamic_text": "Remove dynamic text",
      "validation_empty_amount": "Add a variable or a number first"
    },
    "stop_other": {
      "off": "Off",
      "on": "On"
    },
    "calculate_due_date": {
      "title": "Calculate due date",
      "description": "The due date is calculated from the invoice date and the creditor’s payment terms. If it cannot be calculated, the due date on the document is used instead",
      "description_title": "How the due date is calculated",
      "subtitle": "Calculate due date from creditor payment terms"
    },
    "approve_document": {
      "description_title": "Automatic approval",
      "description": "The document is automatically approved by the system user “{user}” once the document has been validated successfully",
      "subtitle": "Approve the document automatically",
      "title": "Approve document"
    },
    "export_document": {
      "description": "The approved document is exported by the system user “{user}”. Failed exports must be retried manually.",
      "description_title": "Automatic export",
      "title": "Export document",
      "subtitle": "Export the approved document automatically"
    }
  },
  "approval_limits": {
    "final_approver": "Final approver (Unlimited approval limit)",
    "badge_label": "Approval limit",
    "errors": {
      "amount_must_be_non_negative": "Approval-limit amounts cannot be negative.",
      "duplicate_document_type": "Each document type can only have one approval limit.",
      "amount_must_be_positive": "Approval-limit amounts must be greater than zero.",
      "invalid_document_type": "Choose a valid document type."
    },
    "flow_tooltip_edit_title": "Update flow approval limit",
    "restore_title": "Restore approval limit",
    "restore_description": "Restore the user's default approval limit.",
    "one_time_amount_label": "Approval limit",
    "one_time_update_action": "Update approval limit",
    "unlimited": "Unlimited approval limit",
    "one_time_modal_title": "Set flow-specific approval limit",
    "tooltip_readonly_description": "This limit has been set by an Administrator or Bookkeeper.",
    "one_time_modal_hint": "This limit overrides the user's default approval limit in this flow.",
    "tooltip_readonly_title": "Approval Limit",
    "flow_modal_title": "Flow-specific approval limits",
    "set_last_approver_tooltip_description": "Move this approver to the last step in the flow.",
    "final_approver_tooltip_title": "Unlimited approval limit",
    "flow_tooltip_edit_description": "You can set a flow-specific approval limit for this approver.",
    "flow_modal_description": "Set the maximum amount {user} is allowed to approve in this flow.",
    "final_approver_tooltip_description": "The final approver is always assigned an unlimited approval limit to ensure the document can be approved.",
    "tooltip_edit_description": "You can update the user's approval limit.",
    "set_last_approver_tooltip_title": "Set as final approver",
    "tooltip_edit_title": "Update approval limit",
    "multiple": "Multiple approval limits",
    "multiple_limitations": "Multiple limitations",
    "overall_limit": "Overall limit",
    "multiple_limit": "Multiple limits",
    "unlimited_only": "Unlimited"
  },
  "archive": {
    "reason_choice": {
      "processed_outside_system": "Processed outside the system",
      "cancelled_or_credited": "Cancelled or credited",
      "receipt_document": "Account statement",
      "attached_to_other_document": "Attached to other document",
      "delivery_note": "Delivery note"
    },
    "document_reason_message": "Choose a category for the document",
    "meta": {
      "title": "Archives",
      "description": "Archived documents"
    },
    "document": "Move document to Archived"
  },
  "automation": {
    "status": {
      "inactive": "Inactive",
      "active": "Active"
    },
    "save_automation_modals": {
      "automation_name_placeholder": "Enter a name for you automation",
      "description_placeholder": "Enter a description for your automation",
      "automation_name": "Automation name",
      "automation_description": "Description"
    },
    "event": {
      "document-received": "Document received"
    },
    "actions": {
      "sent_to_user": "Sent to {user}",
      "no_creditor_number_found": "No creditor number was found",
      "no_accounting_lines_found": "No accounting lines were found",
      "no_recent_accounting_lines_found": "No recent accounting lines were found",
      "invalid_flow": "The selected flow was invalid",
      "applied_most_used_accounting_lines": "Applied {created_lines} frequently used accounting lines for {creditor} ({documentType}), total {amount}",
      "auto_account_invoice_failed": "Automatic accounting did not complete",
      "note_created": "Note created",
      "handler_block_type_mismatch": "The saved block type did not match this action",
      "no_recent_items_found": "No recent items were found",
      "applied_recent_journal_entry": "Applied {created_lines} recent accounting lines for {creditor} ({documentType}), total {amount}",
      "invalid_user": "The selected user was invalid",
      "invalid_note": "The note was invalid",
      "sent_to_flow": "Sent to {flow}",
      "assigned_to_flow": "Assigned to {flow}",
      "assigned_to_user": "Assigned to {user}",
      "auto_account_invoice_completed": "Automatic accounting completed with {suggested_line_count} suggested lines",
      "created_journal_entries": "Created {created_lines} accounting lines for {creditor} ({documentType}), total {amount}",
      "due_date_payment_term_unsupported": "The due date could not be calculated from the creditor’s payment terms.",
      "due_date_invoice_date_missing": "The due date could not be calculated because the invoice date is missing.",
      "due_date_calculated": "The calculated due date has been applied.",
      "due_date_payment_term_missing": "The due date could not be calculated because the creditor’s payment terms are missing.",
      "due_date_creditor_missing": "The due date could not be calculated because the creditor is missing.",
      "due_date_unchanged": "The due date is unchanged.",
      "export_not_applied": "The document must be approved and must not have been submitted for export before.",
      "export_requested": "Document submitted for export.",
      "document_approval_not_applied": "The document cannot be approved in its current state.",
      "document_approved": "The document was approved by the automation user."
    },
    "history": {
      "succeeded": "Succeeded",
      "block_details": "Block result",
      "open_in_automations": "Open in automations",
      "status": "Status",
      "queued": "Queued",
      "result": "Result",
      "not_visited": "Not visited in this run",
      "hide_details": "Hide run details",
      "did_not_pass": "Did not pass",
      "description": "Inspect the saved automation definition and the result of every visited block.",
      "duration": "Duration",
      "finished": "Finished",
      "interrupted": "Interrupted",
      "title": "Automation run history",
      "in_progress": "In progress",
      "unavailable": "Run history is unavailable.",
      "loading": "Loading run history",
      "queued_at": "Queued {date}",
      "started": "Started",
      "show_details": "Show run details",
      "additional_execution_description": "These visited blocks were not present in the definition captured when the run was queued.",
      "failed": "Failed",
      "additional_execution": "Additional execution evidence",
      "ran_automation": "Ran automation: {automation}",
      "partial_snapshot": "Some saved snapshots could not be read. Available execution evidence is shown.",
      "unknown_automation": "Unknown automation",
      "unavailable_value": "Unavailable",
      "fit_to_view": "Fit to view",
      "loop_iteration": "Iteration {index}: {source}",
      "stopped_subsequent_automations": "Stopped subsequent automations"
    },
    "block": {
      "result_unavailable": "No result was recorded",
      "interrupted": "Execution was interrupted",
      "failed": "The block failed"
    },
    "loops": {
      "not_implemented": "Loops are not implemented"
    },
    "open_automation": "Open automation",
    "template_deleted_title": "Automation disabled",
    "template_deleted_body": "Automation \"{automation}\" was disabled because journal template \"{template}\" was deleted."
  },
  "attachment": {
    "delete": {
      "warning2": "This action cannot be undone.",
      "yes_delete": "Yes, delete attachment",
      "header": "Are you sure you wish to delete the attachment?",
      "warning": "This action will remove the attachment from the document."
    }
  },
  "bottomsheet": {
    "logout_message": "Looks like you’ve been signed out from Batchflow."
  },
  "columns": {
    "actions": "Actions",
    "approvals": "Approvals",
    "status": "Status",
    "time_spent": "Time spent",
    "export_time": "Attempted export",
    "archived_date": "Archived Date",
    "export_status": "Status",
    "deletion_date": "Deletion date",
    "on_hold_reason": "On hold reason",
    "creditor": "Creditor",
    "export_type": "Error",
    "company": "Company",
    "created": "Creation date",
    "approvers": "Approvers",
    "export_date": "Export date",
    "decline_reason": "Decline reason",
    "reason": "Reason",
    "show_document": "Preview document",
    "project_number": "Project number",
    "due_date": "Due date",
    "notes": "Comments",
    "voucher_number": "Voucher number",
    "approved_by": "Approvers",
    "validation": "Validation",
    "guid": "Guid",
    "invoice_id": "Invoice number",
    "docid": "Document ID",
    "export_error": "Error",
    "rejected_by": "Decliners",
    "category": "Category",
    "document_type": "Document type",
    "assignee": "Assignee(s)",
    "showdoc": "Preview document",
    "total_amount": "Total amount",
    "invoice_date": "Invoice date",
    "department": "Department",
    "location": "Location"
  },
  "command_palette": {
    "dates": {
      "current_month": "Current month",
      "last_90_days": "Last 90 days",
      "last_month": "Last month",
      "last_60_days": "Last 60 days",
      "current_quarter": "Current quarter",
      "last_quarter": "Last quarter",
      "last_30_days": "Last 30 days",
      "operator": "Date"
    },
    "placeholder": "Type a command or search...",
    "filter": {
      "creditor": "Creditor",
      "currency": "Currency",
      "amount": "Amount",
      "posting": "Posting",
      "filter_by_amount": "Filter by amount",
      "payment_type": "Payment type",
      "filter_by_status": "Filter by status",
      "ocr": "OCR",
      "filter_by_payment_method": "Filter by payment type",
      "date": "Date",
      "document_type": "Document type",
      "flow": "Flow",
      "status": "Status",
      "filter_by_posting": "Filter by posting",
      "filter_by_date": "Filter by date",
      "filter_by_document_type": "Filter by document type",
      "filter_by_invoiceno": "Filter by invoice number",
      "filter_by_flow": "Filter by flow",
      "filter_by_ocr": "Filter by OCR",
      "filter_by_creditor": "Filter by creditor",
      "filter_by_currency": "Currency",
      "company": "Company",
      "assigned_to_out_of_office_users": "Assigned to out-of-office users",
      "filter_by_assignee": "Filter by assignee",
      "filter_by_vouchernumber": "Filter by voucher number",
      "filter_by_document_id": "Filter by document ID",
      "assigned_to": "Assigned to",
      "assignee": "Assignee"
    },
    "status": {
      "exported": "Exported",
      "approved": "Approved",
      "export_error": "Export errors",
      "deleted": "Deleted",
      "archive": "Archive",
      "declined": "Declined",
      "my_inbox": "My inbox",
      "new_documents": "New documents",
      "under_review": "Under review",
      "on_hold": "On hold"
    },
    "groups": {
      "filter_by_company": "Filter by company",
      "suggestions": "Suggestions",
      "go_to_widget": "Go to widget"
    },
    "operator": {
      "on": "On",
      "is_less_than": "Is less than",
      "is_bigger_than": "Is bigger than",
      "equal_to": "Is equal to",
      "before": "Before",
      "like": "Like",
      "range": "Range",
      "after": "After"
    },
    "keybinds": {
      "to_go_back": "to go back",
      "to_close": "to close",
      "to_select": "to select",
      "press": "Press",
      "to_navigate": "to navigate"
    },
    "search": {
      "check_spelling_or_try_again": "Check spelling or try another search prompt",
      "please_wait_while_we_check": "Please wait while we check",
      "search_for": "Search for '{search}'",
      "searching": "Searching...",
      "no_results_found": "No results were found"
    },
    "result": {
      "show_all_documents": "Show {count} document | Show all {count} documents",
      "documents": "Documents",
      "show_more": "Show more",
      "lists": "Lists",
      "show_documents_in_widget": "Show {count} in {widget}",
      "no_assignees": "No assignees"
    },
    "results": {
      "archived_documents": "Archived documents"
    },
    "amount": {
      "operator": "Amount"
    },
    "widget_action": {
      "go_to": "Go to {widget}",
      "go_to_inbound": "Go to Inbound"
    }
  },
  "creditors": {
    "creditor": {
      "contact_email": "Contact email",
      "address": "Address",
      "cvr": "VAT number",
      "phone_number": "Phone number",
      "payment_scheme": "Payment type",
      "standard_currency": "Standard currency",
      "creditor_id": "Creditor ID",
      "currency": "Currency",
      "registration_number": "Registration number",
      "contact_details": "Contact details",
      "payment_details": "Payment details",
      "name": "Creditor name",
      "country": "Country",
      "contact_name": "Contact name",
      "type": "Type",
      "city": "City",
      "account_number": "Account number",
      "zip_code": "ZIP code",
      "details": "Creditor details",
      "contact_phone": "Contact phone number",
      "payment_terms": "Payment terms",
      "creditor_number": "Creditor number"
    },
    "columns": {
      "creditornumber": "Creditor number",
      "cvr": "VAT number",
      "name": "Name",
      "address": "Address"
    },
    "search_and_filter": "Search and filter for Name, Creditor no., or VAT no."
  },
  "costtype": {
    "fields": {
      "ongoingaccountnumber": "Account number - ongoing",
      "closedaccountnumber": "Account number - closed",
      "active": "Active",
      "markup": "Markup percentage",
      "costtypenumber": "Cost type number",
      "vatcode": "VAT code"
    }
  },
  "datepicker": {
    "choose_a_date_range": "Choose a date range",
    "apply_range": "Apply range",
    "choose_a_date": "Choose a date"
  },
  "confirm": {
    "email": {
      "title": "Your new email is now verified!",
      "button": "Login with your new mail",
      "description": "You’ve successfully confirmed your new email address, which can now be used to\naccess Batchflow"
    }
  },
  "document": {
    "return_toast": "Document returned",
    "permanent_delete_message": "The document will be permanently deleted from Batchflow.",
    "archive_return_message": "The document will be removed from delete and returned to Archive",
    "place_on_hold": "Document placed on hold",
    "permanently_delete": "Permanently delete",
    "return": "Return",
    "flow": "Document Flow",
    "re_export_message": "The document will be sent to {erpname} again.\n",
    "clear_search": "Clear search",
    "change_category": "Change category",
    "change_archive_category_message": "Please choose an archive category for this document ",
    "re_export": "Export again",
    "return_title": "Are you sure you wish to return the document?",
    "re_export_error": "Document couldn't be exported again.",
    "search": "Search",
    "delete_placeholder": "Specify the reason for deleting the document",
    "re_export_title": "Are you sure you want to export this document again?",
    "return_from_hold": "Document returned",
    "deletion_note": "Reason for deletion",
    "delete": "Delete",
    "direction": "Direction",
    "change_archive_category": "Change archive category",
    "return_success": "Archived document to new document",
    "return_from_delete_message": "The document will be removed from Deleted and returned to",
    "approved": "Document was approved",
    "return_error": "Document returning failed!",
    "declined": "Document was declined",
    "move_to_exported": "Move to Exported",
    "action_initial_message": "Please select which action you wish to perform on the document.",
    "return_message": "The document will be removed from Archived and returned to \nNew Documents",
    "move_to_archive": "Move to Archived",
    "sorting": "Sorting",
    "permently_delete": "Are you sure you wish to permanently delete the document?",
    "permanently_delete_title": "Are you sure you wish to permanently delete the document?",
    "export": {
      "re_export": "Export this document again",
      "in_progress_title": "Your document is being exported",
      "in_progress_message": "If the export is successful, a voucher number will be returned by {erpname}. This may take a few minutes.",
      "in_progress_help_text": "While the export is in progress, the document will appear in Outbound. Once completed, it will move to Exported.",
      "re_export_success": "You have exported the document again.",
      "re_export_success_toast_title": "Document has been exported again.",
      "dont_show_again": "Don't show again"
    },
    "reason": {
      "change_category_error": "Item category change failed!"
    },
    "item": {
      "return_from": "From",
      "return_to": "You have returned the document to"
    },
    "active": {
      "title": "Active document"
    },
    "yes_re_export": "Yes, export again",
    "yes_permanently_delete": "Yes, permanently delete",
    "archive": {
      "toast_message": "You have successfully changed the archive category to ",
      "toast_title": "Archive category changed"
    },
    "duplicate": {
      "title": "Duplicate document"
    },
    "return_to_widget_message": "The document will be returned to",
    "sorting_and_company": "Sorting & companies"
  },
  "dates": {
    "today": "Today",
    "older": "Older",
    "yesterday": "Yesterday"
  },
  "default": {
    "not_set": "Not set"
  },
  "details": {
    "meta": {
      "title": "Details",
      "description": "Inspect your invoice details"
    }
  },
  "documents": {
    "entry": {
      "view": "View",
      "days_in_inbox": "{days} in inbox",
      "review_started": "{days} since review start",
      "last_reminded": "Last reminded",
      "exported": "Exported",
      "you_can_remind_again": "You can remind again {time}",
      "cant_remind_yourself": "You can't send reminders to yourself. ",
      "not_set": "Not set",
      "remind_assignee": "Remind",
      "last_viewed": "Last viewed",
      "assignee": "Assignee"
    },
    "empty": {
      "subheader": "Move on to your next task... or take a coffee break.",
      "header": "You're all caught up!"
    },
    "meta": {
      "description": "View your documents",
      "title": "Documents"
    },
    "preview": {
      "title": "Document preview"
    },
    "search_empty": {
      "header": "The search box is empty!",
      "subheader": "Unfortunately, we couldn't find what you were looking for. Please try a new search."
    },
    "list": {
      "end_of_list": "It looks like you've seen it all! You've reached the end of the list."
    },
    "validation": {
      "issues": "{count} Issue | {count} issues"
    },
    "alerts": {
      "overdue_days": "{count} day overdue | {count} days overdue",
      "due_today": "Due today",
      "overdue": "Overdue",
      "title": "Alerts",
      "due_in_days": "Due in {count} day | Due in {count} days"
    }
  },
  "economic_integration": {
    "expansions": {
      "projects": "Projects",
      "header": "Expansions"
    },
    "api_details": {
      "header": "API Details",
      "how_do_i_find_api_token": "How do i find my e-conomic API token?",
      "connection_established": "Connected",
      "subtitle": "Please provide an API token",
      "api_token": "e-conomic API token"
    },
    "configuration": {
      "header": "e-conomic integration"
    },
    "dimensions": {
      "subtitle": "Please select which dimensions to include",
      "show_dimension": "Show '{dimension}'",
      "header": "Dimensions"
    },
    "journal_details": {
      "header": "Journal",
      "how_do_i_find_journals": "How do i find my e-conomic journals, and which one should I choose?",
      "subtitle": "Please select which journal to use",
      "journal": "Journal in e-conomic"
    },
    "sections": {
      "latest_job_status_3": "Failed",
      "section_3": "Payment types",
      "next_run": "Next run",
      "section_8": "Vat accounts",
      "section_7": "Dimensions",
      "section_-1": "Export",
      "section_1": "Suppliers",
      "enabled": "Enabled",
      "completion_time": "Completion time",
      "last_run": "Last run",
      "section_0": "Accounts",
      "section_10": "Employees",
      "section_9": "Units",
      "latest_job_status_0": "Pending",
      "latest_job_status_processed_items": "Processed {count} items",
      "section_2": "Payment terms",
      "force_run": "Run",
      "section": "Section",
      "interval": "Interval",
      "latest_job": "Latest job",
      "header": "Sections"
    },
    "webhooks": {
      "webhook_type_10": "Employee updated",
      "webhook_type_2": "Payment term updated",
      "webhook_type_0": "Chart of accounts updated",
      "webhook_type_8": "Vat code updated",
      "webhook_type_5": "Project updated",
      "webhook_type_1": "Supplier updated",
      "webhook_type_7": "Dimension updated",
      "webhook_type_9": "Unit updated",
      "url": "URL",
      "body": "Sent data",
      "type": "Type"
    },
    "setup": {
      "header": "Setup e-conomic integration",
      "back": "Back",
      "next": "Next",
      "completing_setup": "Completing setup",
      "verifying_connection": "Verifying token",
      "verify_connection": "Verify token",
      "complete": "Complete setup"
    },
    "units": {
      "subtitle": "Please select which dimensions to include",
      "header": "Units",
      "enable_unit": "Enable Unit{unit} / Quantity{unit}"
    }
  },
  "document_types": {
    "customer_order": "Customer order",
    "invoice": "Cost invoice",
    "travel": "Travel",
    "requisition": "Requisition",
    "creditnote": "Cost credit note",
    "split": "Split",
    "goods_credit_note": "Goods credit note",
    "mileage": "Mileage",
    "goods_invoice": "Goods invoice",
    "expense": "Expense",
    "credit_note": "Cost credit note"
  },
  "due": {
    "date": "Due"
  },
  "document_status": {
    "exported": "Exported",
    "declined": "Declined",
    "under_review": "Under review",
    "approved": "Approved",
    "exporting": "Exporting",
    "notinflow": "New Documents",
    "archived": "Archived",
    "export_failed": "Export error",
    "on_hold": "On hold"
  },
  "emails": {
    "bulk_reminder": {
      "greeting": "Hi",
      "would_like_to_remind_you": "would like to remind you that you have",
      "documents": "documents",
      "pending_for_review": "pending for review.",
      "open_batchflow": "Open Batchflow",
      "subtitle": "You have pending documents",
      "questions_or_assistance": "If you have any questions or need assistance, please contact us at",
      "subject": "You have pending documents",
      "document_review_request": "The document(s) review request is important and should be addressed as soon as possible. Open Batchflow to begin the reviewing process."
    },
    "the_batchflow_team": "The Batchflow team",
    "company_invitation": {
      "greeting": "Hi",
      "in_batchflow": "in Batchflow",
      "would_like_to_invite_you_to_organisation": "would like to invite you to join the organization",
      "you_have_been_invited": "You have been invited",
      "open_invitation_to_get_started": "Open the invitation to get your user set up and start working with Batchflow. Please note that the invitation will expire after a month",
      "open_batchflow_to_get_started_multiple": "Open Batchflow and log in to see documents regarding the new companies",
      "questions_or_assistance": "If you have any questions or need assistance, please contact us at",
      "open_invitation": "Open invitation",
      "subject": "You have been invited",
      "open_batchflow_to_get_started": "Open Batchflow and log in to see documents regarding the new company",
      "would_like_to_invite_you_to_company": "would like to invite you to join the company",
      "open_batchflow": "Open Batchflow"
    },
    "thank_you": "Thank you,",
    "general": {
      "open_batchflow": "Open Batchflow",
      "questions_or_assistance": "If you have any questions or need assistance, please contact us at"
    },
    "forgot_password": {
      "subject": "Reset your password",
      "password_reset_valid_4": "once.",
      "reset_password_button": "Reset your password",
      "request_reset_password": "A request has been made to reset the password for your Batchflow account.",
      "password_reset_valid_1": "This password reset request is",
      "greeting": "Hi,",
      "password_reset_valid_3": "valid for the next 24 hours, and can only be used",
      "password_reset_valid_2": "only",
      "subtitle": "Let's reset your password",
      "reset_request_warning": "If you did not request this password reset, then please contact us at"
    },
    "confirm_email": {
      "request_to_change_email": "A request has been made to change the email you use to log in to Batchflow.",
      "if_not_you_then_contact_us": "If you did not request this email change, then please contact us at",
      "subject": "Confirm your new email",
      "is_this_your_new_email": "Is this your new email?",
      "greeting": "Hi",
      "verify_email": "Verify new email",
      "please_verify_new_email": "Please verify that this is the new email you will use to log in to Batchflow and receive messages in the future."
    },
    "reminder": {
      "would_like_to_remind_you": "would like to remind you that you have a document pending for review.",
      "due_date": "Due",
      "subject": "You have a pending document",
      "document_review_request": "The document review request is important and should be addressed as soon as possible. Open Batchflow to begin the reviewing process."
    },
    "daily_inbox_reminder": {
      "overdue_body_emphasis": "immediately",
      "current_month_title": "Month-end approaching",
      "current_month_body_after_count": "document(s) were received earlier this month and are still pending your approval. Approving them now helps ensure a smooth and timely month-end closing.",
      "greeting": "Hi",
      "due_soon_title": "Due date approaching",
      "overdue_body_prefix": "document(s) are now past their due date and still pending your approval. Please review these",
      "due_soon_body_after_count": "document(s) are nearing their due date and still await your approval. Please review them promptly to avoid delays and late processing.",
      "overdue_body_suffix": "to avoid further delays.",
      "body": "You have {count} document(s) pending review and approval.",
      "timely_approval_emphasis": "timely approval is critical",
      "subject": "Batchflow | You have pending documents",
      "pending_body_suffix": "pending review and approval.",
      "why_it_matters": "Why it matters?",
      "review_pending_documents": "Review pending documents",
      "previous_month_title": "Pending from last month",
      "timely_approval_prefix": "Although the document(s) might not be due just yet,",
      "why_it_matters_third": "Documents from last month are especially important to handle right away",
      "why_it_matters_first": "The bookkeeping team relies on your approval to post documents in time for month-end closing",
      "overdue_title": "Overdue",
      "pending_body_count_suffix": "document(s)",
      "previous_month_body_after_count": "document(s) were received last month, and are still pending your approval. These need attention as soon as possible to ensure accurate month-end closing.",
      "title": "You have pending documents",
      "pending_body_prefix": "You have",
      "review_prompt": "Please take a moment to review and approve your pending document(s)",
      "why_it_matters_second": "Delays cause frustration and can lead to incomplete or late reporting",
      "timely_approval_suffix": "- especially when we approach the end of the month.",
      "previous_months_title": "Pending from previous months"
    },
    "address": "Mileparken 22, 2. - DK-2740 Skovlunde"
  },
  "economic_integrations": {
    "webhooks": {
      "copy_url": "Copy URL",
      "header": "Webhooks",
      "copy_body": "Copy sent data",
      "how_to_setup_webhooks": "How do i setup webhooks in e-conomic?"
    }
  },
  "erp": {
    "name": {
      "2": "e-conomic",
      "3": "Uniconta",
      "5": "Ordrestyring",
      "6": "Dataløn",
      "7": "Zenegy",
      "9": "SAP Business One",
      "10": "Minuba",
      "11": "MicroBizz",
      "12": "Business Central",
      "unknown": "Unknown"
    }
  },
  "employee": {
    "fields": {
      "active": "Active",
      "address": "Address",
      "phone": "Phone",
      "email": "Email",
      "employeenumber": "Employee number",
      "groupnumber": "Group number",
      "zipcode": "ZIP code",
      "city": "City"
    }
  },
  "enablemfa": {
    "bottomtext": "Don’t have an authenticator app? Try {link}",
    "complete_title": "Authentication setup complete",
    "meta": {
      "description": "Enable Multi-Factor Authentication for your account",
      "title": "Multi-factor"
    },
    "back": "Continue to Batchflow",
    "success": "In the future you will need your authenticator app in combination with your email and password to log in.<br/><br/>Keep your recovery codes safe to access your account in case you loose access to your authenticator app.",
    "title": "Setup two-factor authentication",
    "completing": "Completing two-factor setup",
    "complete_subtitle": "For the account <b>{email}</b>",
    "invalid_code": "The code is not valid, please try again",
    "success_title": "Authentication app has been set up",
    "complete": "Complete two-factor setup",
    "recoverycodes": "Recovery codes:",
    "subtitle": "Scan the QR code with your authenticator app and enter the 6-digit code shown in the app",
    "error": {
      "6digit_code": "A 6-digit code is required"
    },
    "mobile": {
      "bottomtext": "Don’t have an authenticator app? \n",
      "trytext": "Try"
    },
    "qrcode": {
      "code_copy_success": "Qrcode copied successfully!",
      "continue": "Continue",
      "title": "Set up two-factor",
      "copy_failed": "QR code could not be copied.\n",
      "copy": "Copy code",
      "subtitle": "Copy this code and enter it in your authenticator app"
    },
    "code": {
      "subtitle": "Enter the 6-digit code shown in the app"
    }
  },
  "exported": {
    "reason_choice": {
      "entered_manually_in_erp": "Entered manually in ERP",
      "already_exists_in_erp": "Already exists in ERP",
      "export_error_resolved_outside_batchflow": "Export issue resolved outside BatchFlow"
    },
    "document_reason_message": "Choose a reason for marking the document as exported",
    "document": "Move document to Exported"
  },
  "excel": {
    "fields": {
      "creditor": "Creditor number",
      "bankaccountnumber": "Account number"
    },
    "download": {
      "message": "This might take a few moments...",
      "title": "Getting your excel file ready",
      "error_message": "The Excel file could not be downloaded. Try again.",
      "missing_data": "There is no data available to export.",
      "error_title": "Excel download failed"
    }
  },
  "export_bulk": {
    "toast_title": "Document exported | Documents exported",
    "progress_title": "Exporting documents",
    "go_to_document": "Go to document | Go to documents",
    "toast_message": "{count} document was successfully exported. | {count} documents were successfully exported.",
    "confirm_validate": "The document will be validated before export. If it has no validation errors, it will be exported automatically. | All documents will be validated before export. Documents without validation errors will be exported automatically.",
    "confirm_guide": "If the document contains errors, you will be guided through it so it can be corrected manually. | If any documents contain errors, you will be guided through them so they can be corrected manually.",
    "issue_title": "Export validation issue | Export validation issues",
    "confirm_title": "Are you sure you wish to export {count} document? | Are you sure you wish to export {count} documents?",
    "error_message": "Bulk export could not be completed.",
    "progress_details": "Cancelling only affects document not yet exported. Completed exports won't be undone.",
    "optional_issue_message": "{count} document has validation issues. | {count} documents have validation issues.",
    "confirm_action": "Export document | Export documents",
    "mandatory_issue_message": "{count} document has validation issues. | {count} documents have validation issues.",
    "issue_cta": "Do you want to review and correct it now? | Do you want to review and correct them now?",
    "progress_message": "This might take a few moments",
    "cancel_action": "Cancel"
  },
  "fields": {
    "password_validation": {
      "numeric": "A number",
      "upperlower": "Upper & lower case letters",
      "nonalfa": "A symbol (e.g. #&%)",
      "title": "Create a secure password",
      "length": "8 characters long"
    },
    "payment_methods": {
      "none": "None",
      "international": "International",
      "bank_account": "Bank account",
      "fik": "FI code",
      "entry_only": "Posting only"
    }
  },
  "flow": {
    "edit": {
      "edit_flow_replace_me": "Replace me",
      "edit_flow_replace_me_message": "Choose someone to replace you",
      "approver_before_me_message": "Insert approver before you in flow",
      "approver_before_me": "Add approver before me",
      "approver_after_me_message": "Insert approver after you in flow",
      "add_approver": "Add approver",
      "approver_after_me": "Add approver after me",
      "choose_update_method": "Choose an update method",
      "edit_flow_message": "Find someone to replace you or add another approver",
      "edit_flow_title": "Edit the current flow",
      "replace_me": "Replace me",
      "flow_choose_update_method": "Choose an update method"
    },
    "approve_count": "{count} approval required | {count} approvals required",
    "approval_limit": "Approval limit",
    "stepflow": "Stepflow",
    "close": "Luk",
    "using_flow_named": "Using {type}: {name}",
    "using_noflow": "Flow is not set up",
    "next_step": "Next step",
    "next_approver": "Next approver",
    "currently_active": "Currently active",
    "using_stepflow": "Using stepflow",
    "using_multiflow": "Using multiflow",
    "multiflow": "Multiflow",
    "warnings": {
      "approve_warning_tooltip_1": "With the current settings, everyone may respond without the document being approved or declined. Please adjust the rules to avoid this situation.",
      "continue_anyway": "Continue anyway",
      "approve_count_warning_description_2": "Please adjust the rules to avoid this situation.",
      "approve_count_warning_description_1": "With the current settings, everyone may respond without the document being approved or declined.",
      "approve_count_warning_footer": "If a final decision can’t be reached, the document will be automatically declined.",
      "adjust_rules": "Adjust rules",
      "approve_count_warning_title": "This flow setup can’t guarantee a final decision",
      "approve_warning_tooltip_2": "If a final decision can’t be reached, the document will be automatically declined."
    },
    "errors": {
      "flow_template_name_already_exists": "Der findes allerede et flow med dette navn",
      "flow_profile_name_already_exists": "A flow with that name already exists",
      "approval_limit_must_be_positive": "Approval-limit amounts must be greater than zero.",
      "invalid_approval_limit_mode": "Choose a valid approval-limit mode."
    },
    "forward_to": {
      "updated_flow_card_title": "Edit the updated flow",
      "updated_flow": "The updated flow"
    },
    "list": {
      "list_updated_approver": "List of approvers in the updated flow",
      "list_approver": "List of approvers in the current flow",
      "choose_approver_list": "Choose an approver to replace you in the current flow",
      "approver_list_after_title": "Choose an approver to insert after you in the current flow",
      "approver_list_before_title": "Choose an approver to insert before you in the current flow"
    },
    "users": {
      "search_placeholder": "Search for a name or an email"
    },
    "using_flowtype": {
      "multiflow": "Using Multiflow: {flowName}",
      "stepflow": "Using Stepflow: {flowName}"
    },
    "meta": {
      "title": "flow"
    }
  },
  "exporterror": {
    "message": {
      "go_to_log": "Go to log"
    }
  },
  "flowstate": {
    "toast": {
      "button_text": "Go to document",
      "add_approver_message": "Has added you to the review process for a document.",
      "replace_me": "Flow updated",
      "replace_me_message": "You have successfully updated the flow on the following document."
    },
    "upcoming": {
      "emptystate": "Approved",
      "empty_message_self": "{name} are the last approver",
      "empty_message": "{name} is the last approver"
    },
    "usernotfound": "Unknown user",
    "state": {
      "approvals": "Approvals",
      "approved": "Approved",
      "declined_document": "Has already declined the document",
      "declined": "Declined",
      "approved_document": "Has already approved the document",
      "inprogress": "In progress",
      "processed": "Processed",
      "declines": "Declines",
      "upcoming": "Upcoming"
    },
    "self": "You",
    "remaining": {
      "approvers": "{count} approvers remaining",
      "approver": "{count} approver remaining",
      "noone": "No approvers remaining"
    },
    "approve_count": "{count} approval | {count} approvals",
    "notset": {
      "details": "Choose approver(s) or flow to begin the reviewing process",
      "header": "Approvers or flow are not set up"
    },
    "delegate_for": "Delegate for {user}",
    "header": {
      "onetimeflow": "One-time flow"
    },
    "date": {
      "days": "{days} days ago",
      "today": "Today {time}"
    },
    "no_declines": "No declines",
    "selected": {
      "button": "Change",
      "header": "is selected"
    },
    "edit": {
      "already_in_flow": "Already in flow",
      "approver_before_me": "Will be the new next approver",
      "replace_me": "Will replace you",
      "approver_after_me": "Will be the new next approver after you",
      "insufficient_approval_limit": "Insufficient approval limit",
      "insufficient_approval_limit_tooltip": "This approver cannot be inserted after you because their approval limit is not sufficient to act as the final approver in the flow."
    },
    "decline_count": "{count} decline | {count} declines",
    "you": "You",
    "no_declined": "No decline",
    "no_approvals": "No approvals",
    "delegatefor": "Delegate for {user}",
    "update": {
      "yes_sure": "Yes, I’m sure",
      "approver_order": "Are you sure you wish to change the flow’s approval order?",
      "replace_me_2": "This action will replace you in the flow, and you will no longer be able to access the document.",
      "approver_before_me_2": "This action will insert ",
      "approver_before_me_3": "before you in the flow - you will get the document afterwards if necessary.",
      "update_flow": "Update flow",
      "replace_me_1": "Are you sure you wish to be replaced?",
      "approver_after_me_3": "after you in the current flow."
    },
    "acting": {
      "delegate_for_tooltip": "Acted as delegate for {user}"
    },
    "remaning": {
      "approvers": "Remaining approvers"
    }
  },
  "forgotpassword": {
    "reset": "Reset password",
    "result_title_error": "Error sending email to",
    "meta": {
      "title": "Forgot password",
      "description": "Reset your password"
    },
    "result_title_success": "Email sent to",
    "back": "Back to login",
    "sub_title_success": "We emailed you instructions on how to reset your password",
    "sub_title_error": "An error occurred while sending the email. Please try again later.",
    "result_message_error": "An error occurred while sending your email. Please try again later.",
    "sub_title": "We will email you instructions on how to reset your password",
    "bottom_text": "If you don't see a reset email, then be sure to check your spam filter for an email from <b>{supportemail}</b>",
    "title_error": "Error sending email",
    "enter_email": "Enter your email",
    "title": "Forgot password?",
    "result_message_success": "You will have received an mail with a link to reset your password, if the email you provided is associated with a valid account.<br/><br/>If you did not receive an email, then please check your spam folder and make sure the provided mail is correct.<br/>The mail is sent from <b>{replyemail}</b><br><br>If you still did not receive an email, please try to reset your password again or contact our Support Team.",
    "title_success": "Email sent",
    "email": "Email",
    "resetting": "Resetting password"
  },
  "global": {
    "disabled": "Disabled",
    "to": "To",
    "assignee": "assignee",
    "self": "You",
    "today": "Today",
    "and": "and",
    "mandatory": "Mandatory",
    "yesterday": "Yesterday",
    "enabled": "Enabled",
    "assignees": "Assignees",
    "indefinitely": "Indefinitely",
    "optional": "Optional",
    "self_object": "You",
    "from": "From"
  },
  "inbound": {
    "columns": {
      "company": "Company",
      "received_date": "Received date",
      "from": "Sender",
      "time_spent": "Time spent",
      "ocr_type": "OCR Type",
      "subject": "Subject",
      "receival_type": "Source type",
      "status": "Status\n"
    },
    "empty": {
      "email_example": "Email example: {email}",
      "view_emails_in_administration": "View you email addresses in Settings",
      "no_documents_yet": "You haven't received any documents yet...",
      "start_sending_documents": "Start sending documents as attachments to your inbound Batchflow email, and they will show up here.",
      "go_to_inbound_administration": "Go to Settings"
    },
    "document": {
      "reprocessing_started_header": "Reprocessing started",
      "reprocessing_started": "The document has been sent for reprocessing and will be ready in a short while",
      "reprocess_document": "Send to reprocessing",
      "reprocessing_failed": "An error occurred when we attempted to send the document for reprocessing",
      "reprocessing_failed_header": "We encountered an error reprocessing"
    },
    "ocr": {
      "customer_order_validation_description": "OCR with validation is done by using AI first followed by human-in-the-loop validation. This means all data extracted by the AI is validated by humans to ensure data quality.\n\nUnlike AI, humans do not work around the clock.\nThis means that human validation only takes place within a specific time frame (Monday to Friday from 8:00 to 16:00 CET).\n\nThe average processing time is calculated based on this given time frame, and is an average for the last 30 days..\n\nExample 1:\nA document arrives on Wednesday at 15:00 and is completed on Thursday at 8:30.\nThis results in a processing time of 1,5 hours: 1 hour on Wednesday (15:00–16:00) and 0,5 hour on Thursdag (8:00-8:30).\n\nExample 2:\nA document arrives on Friday at 15:30 and is completed on Monday at 9:30.\nThis results in a processing time of 2 hours: 0,5 hour on Friday (15:30–16:00) and 1,5 hours on Monday (8:00–9:30).",
      "customer_order": "Customer order",
      "ocr_for_customer_order": "OCR with validation for Customer orders",
      "ocr_without_validation": "OCR without validation",
      "with_validation": "With validation",
      "with_validation_description": "OCR with validation is done by using AI first followed by human-in-the-loop validation. This means all data extracted by the AI is validated by humans to ensure data quality.\n\nUnlike AI, humans do not work around the clock.\nThis means that human validation only takes place within a specific time frame (Monday to Friday from 8:00 to 16:00 CET).\n\nThe average processing time is calculated based on this given time frame, and is an average for the last 30 days..\n\nExample 1:\nA document arrives on Wednesday at 15:00 and is completed on Thursday at 14:00.\nThis results in a processing time of 7 hours: 1 hour on Wednesday (15:00–16:00) and 6 hours on Thursday (8:00–14:00).\n\nExample 2:\nA document arrives on Friday at 14:00 and is completed on Monday at 12:00.\nThis results in a processing time of 6 hours: 2 hours on Friday (14:00–16:00) and 4 hours on Monday (8:00–12:00).",
      "ocr_with_validation": "OCR with validation",
      "without_validation": "Without validation",
      "without_validation_description": "OCR without validation is done using only AI with fully automated extraction.\nThe AI wil find the required information to the best of it’s ability.\n\nThe AI works around the clock so the processing starts as soon as the document is received.\n\nThe average processing time calculated is the actual time used by the AI on extracting data, and is an average for the last 30 days."
    },
    "errors": {
      "you_cant_view_this_document": "Sorry! You can't view this document",
      "cannot_reprocess_document": "Cannot re-process this document",
      "failed_validation": "Something went wrong while processing the document",
      "it_looks_like_this_document_is_off_limits": "It looks like this document is off-limits for you. This might be because of access restrictions based on your current role.",
      "processing_error": "Processing error",
      "should_you_have_access": "Think you should have access? Contact your Administrator",
      "document_deleted_or_not_available": "This document has been deleted and is no longer available for re-processing",
      "document_has_not_finished_processing": "The document has not finished processing yet.",
      "header": "Document is still processing"
    },
    "buttons": {
      "update": "Update",
      "update_executing": "Updating",
      "upload_document": "Upload document"
    },
    "actions": {
      "go_to_document": "Go to document",
      "delete": "Delete document"
    },
    "title": "Inbound",
    "received_date": "Received date",
    "stats": {
      "with_validation": "with validation",
      "without_validation": "without validation",
      "processing_time_for": "Avg. processing time for",
      "processing_time": "Avg. processing time",
      "customer_order": "customer orders"
    },
    "receival_type": {
      "vans": "e-Invoice",
      "email": "Email",
      "uts": "UTS"
    },
    "status": {
      "failed": "Error",
      "reprocessing": "Reprocessing",
      "processing": "Processing",
      "done": "Done",
      "processed": "Processed"
    },
    "description": "View and manage inbound documents",
    "search_and_filter": "Search for Company, Subject, or Sender"
  },
  "flow_profiles": {
    "columns": {
      "flow_type": "Flow type",
      "flow_name": "Name",
      "users": "Users"
    },
    "buttons": {
      "create_new_flow": "Create new flow"
    },
    "search_and_filter": "Search and filter for Name or Users"
  },
  "header": {
    "go_back": "Back",
    "profile": "Profile",
    "logout": "Log out",
    "company_filter": {
      "show_all_companies": "Show all companies"
    }
  },
  "item": {
    "attributes": {
      "document_archive_reason": "Reason",
      "document_on_hold_additional_note_description": "See the additional note explaining why the document is on hold",
      "accounted": "Accounted",
      "document_on_hold_reason_description": "See the reason why the document is on hold, along with an additional note explaining why",
      "issues_and": "and",
      "accounted_description": "See the posted amount (sum of journal entries) for the document",
      "document_delete_text": "Document has been deleted",
      "export_error_reason": "Export error",
      "difference": "Difference",
      "document_on_hold_text": "Document is on hold",
      "assignee": "Assignee",
      "export_error_text": "Document has failed to export",
      "document_on_hold_text_description": "See the document status",
      "document_declined_text": "Document has been declined",
      "document_declined_reason": "Reason",
      "assignee_description": "See who the document is assigned to",
      "difference_description": "See the difference between the total amount/net amount and the posted amount on the document",
      "count_validation_issues": "{count} validation issue | {count} validation issues",
      "document_declined_reason_description": "See why the document has been rejected",
      "document_on_hold_reason": "Reason",
      "document_declined_text_description": "See the document status",
      "document_on_hold_additional_note": "Additional note",
      "declined_by_description": "See who rejected the document",
      "assigned": "Assigned",
      "document_delete_reason": "Reason",
      "document_archive_category": "Category",
      "declined_by": "Declined by",
      "export_error_text_description": "See the document status",
      "export_error_reason_description": "See the reason why the document export failed",
      "voucher_missing_reason": "No voucher number was returned from {erp}.",
      "time_remaining": "Time remaining",
      "net_amount": "Net amount",
      "voucher_missing_title": "Missing voucher number",
      "time_remaining_description": "See how long remains before the document is due",
      "no_decline_reason": "No decline reason",
      "voucher_missing_help": "You can manually enter a voucher number if needed.",
      "optional_issues_description": "{count} warning | {count} warnings",
      "no_on_hold_additional_note": "No additional note",
      "no_export_error_reason": "No export error",
      "total_amount": "Total amount",
      "validation_issues": "Validation issues",
      "voucher_pending": "Pending",
      "voucher_missing": "Missing",
      "no_assignee": "Not assigned",
      "validation_errors_description": "See validation errors for the document",
      "no_reminders": "Not reminded",
      "mandatory_issues_description": "{count} error | {count} errors",
      "voucher_received_from": "Received from {erp}",
      "time_assigned": "Time assigned",
      "voucher_elapsed_time": "Elapsed time",
      "no_on_hold_reason": "On hold without reason",
      "voucher_pending_title": "Pending {erp}",
      "no_decline_user": "Not declined by a user",
      "last_reminded": "Last reminder",
      "voucher_received": "Received: {date}",
      "validation_issues_description": "{errors} errors and {warnings} warnings",
      "voucher_updated": "Updated: {date}",
      "voucher_overwritten_by": "Edited by {name}",
      "net_amount_description": "See the Net amount for the document",
      "validation_errors": "Validation errors",
      "voucher_waiting": "Waiting for a voucher number",
      "last_reminded_description": "See when the last reminder was sent",
      "time_assigned_description": "See how long the document has been under review",
      "total_amount_description": "See the Total amount of the document",
      "ready_for_export_text": "Document is ready for export",
      "delete_by": "Deleted by",
      "voucher_number_description": "See the voucher number for the document",
      "document_archive_reason_description": "Allows users to see and edit the Archived category",
      "voucher_number": "Voucher number",
      "due_date": "Due date",
      "delete_by_description": "See who deleted the document",
      "document_delete_reason_description": "See why the document was deleted"
    },
    "accounting": {
      "layout_expanded": "Expanded",
      "layout_standard": "Standard",
      "layout_compact": "Compact",
      "columns": "Columns",
      "no_journal_entries_description": "Add your entries here to begin invoice reconciliation",
      "title": "Journal entries",
      "no_journal_entries": "No entries have been added yet",
      "layout_options": "Layout",
      "layout_dynamic_description": "Grows with your entries, then scrolls when full",
      "layout_compact_description": "Shows only the header, keeping the invoice visible",
      "layout_dynamic": "Adaptive",
      "layout_expanded_description": "Fills the space so you can work with many lines"
    },
    "on_hold": "Place invoice on hold",
    "optional_note": "Add a note (optional)",
    "buttons": {
      "decline": "Decline",
      "executing_export": "Exporting document",
      "change_approvers": "Change approvers",
      "item_approve": "Approve",
      "move_to_archive": "Move document to Archived",
      "remind_assignee_has_been_reminded_today": "{user} has been reminded today",
      "start_review": "Send for review",
      "return_to": "Return to",
      "move_as_archived": "Archived",
      "approve_success_message": "have approved the following document:",
      "place_on_hold": "Place on hold",
      "return_from_hold_success_message": "have returned the following document to <strong>{widget}</strong>",
      "start_review_success_message": "have sent the following document to review:",
      "approve": "Approve",
      "edit_flow": "Edit flow",
      "executing_approve": "Approving",
      "return_from_hold_widget": "Return to {widget}",
      "executing_change_approvers": "Changing approvers",
      "move_document_to": "Move document to",
      "move_to_archived": "Move to Archived",
      "edit_voucher_number": "Edit voucher number",
      "delete": "Delete document",
      "item_decline": "Decline",
      "executing_return_to_assignee": "Return to assignee",
      "return_document": "return document",
      "move_to": "Move to...",
      "put_on_hold_success_message": "Has placed the following document on hold:",
      "email_file_as_pdf": "Send PDF via email",
      "move_as_exported": "Exported",
      "save_file_as_xml": "Download as XML",
      "decline_success_message": "have declined the following document:",
      "executing_start_review": "Sending for review",
      "choose_approvers": "Choose approvers",
      "view_on_hold_reason": "View on hold reason",
      "send_to_archive": "Archived",
      "move_to_exported": "Move to Exported",
      "return_from_hold": "Return from on hold",
      "forward_to": "Forward to...",
      "save_file_as_pdf": "Download as PDF",
      "export_document": "Export document",
      "move_to_exported_success_message": "Has moved the following document to Exported:",
      "remind_assignees": "Remind assignees",
      "remind_assignee": "Remind asignee",
      "send_to_exported": "Exported",
      "move_item_to_another_company": "Another company",
      "document_re_export": "Export again",
      "document_permanently_delete": "Delete permanently ",
      "change_category": "Change category",
      "document_return": "Return",
      "executing_on_hold_return": "Returning",
      "another_document": "Another document",
      "move_to_archive_success_message": "Has moved the following document to Archived:",
      "download_document": "Download as...",
      "download_xml": "XML",
      "print_e_invoice": "E-Invoice",
      "print_document": "Print...",
      "download_pdf": "PDF",
      "print_pdf": "PDF"
    },
    "delete": {
      "30_day_warning_2": "After 90 days, the document will be permanently deleted and will no longer be available.",
      "item_was_permanently_deleted": "You have permanently deleted the document.",
      "30_day_warning_3": "You will be able to see the document in the Deleted widget.",
      "30_day_warning": "The document will be moved to the archive, where it will be stored for 30 days",
      "delete_item_warning": "Do you want to delete this document?",
      "item_was_deleted": "You have deleted the document.",
      "yes_delete_document": "Yes, delete document",
      "permanently_deleted_toast_title": "Document permanently deleted",
      "permanent_delete_error": "Document permanently delete failed!",
      "toast_title": "Document deleted",
      "warning_footer": "Any users connected to this document will be notified about deletion"
    },
    "column": {
      "invoicedate": "Invoice date",
      "netamount": "Net amount",
      "totalamount": "Total amount",
      "invoiceno": "Invoice number",
      "duedate": "Due date",
      "taxamount": "Tax amount"
    },
    "multiple_users": {
      "move_the_document_to_archive": "move the document to archive",
      "export_the_document": "export the document",
      "moving_the_document_to_exported": "Moving the document to exported",
      "are_you_sure_action": "Are you sure you wish to {action}?",
      "moving_the_document_to_archive": "Moving the document to archive",
      "approve_the_document": "approve the document",
      "returning_document_to_state": "Returning the document",
      "document_no_longer_available": "The document is no longer available",
      "approving_the_document": "Approving the document",
      "document_no_longer_available_text": "Another user has performed an action that has changed the document's state, making it unavailable for you to edit or make changes to.",
      "move_to_exported": "move to exported",
      "exporting_the_document": "Exporting the document",
      "decline_the_document": "decline the document",
      "move_the_document_to_exported": "move the document to exported",
      "declining_the_document": "Declining the document",
      "action_cannot_be_undone": "This action cannot be undone.",
      "deleting_the_document": "Deleting the document",
      "delete_the_document": "delete the document",
      "you_will_be_taken_to_next_document": "You’ll go to the next document or back to the list.\n",
      "warning_action_result": "{action} will remove the active users' access to the document.",
      "move_to_archive": "move to Archived",
      "send_the_document_to_exported": "move the document to exported",
      "sending_the_document_for_review": "Sending the document for review",
      "return_document_to_state": "return the document to {state}",
      "set_the_document_on_hold": "set the document on hold",
      "send_the_document_to_archive": "move the document to archive",
      "sending_the_document_to_exported": "Moving the document to exported",
      "setting_the_document_on_hold": "Setting the document on hold",
      "send_the_document_for_review": "send the document for review",
      "sending_the_document_to_archive": "Moving the document to archive"
    },
    "details": {
      "document_id": "Document ID",
      "cost_credit_note": "Cost credit note",
      "link_copied_to_clipboard": "Link copied",
      "next_document": "Next document",
      "invoice_no": "Document ID",
      "creation_date": "Creation date",
      "document_actions": "Document actions",
      "document_type_updated": "Document type has been updated.",
      "expand_fields": "Expand fields",
      "previous_document": "Previous document",
      "link_copied_to_item": "Copied link (URL) to Batchflow ID #{docId}",
      "goods_credit_note": "Goods credit note",
      "documents_remaining": "{count} Document remaining | {count} Documents remaining",
      "copied": "Copied",
      "comments": "Comments",
      "activity_log": "Activity log",
      "show_duplicates": "Show duplicate | Show duplicates",
      "attachments": "Attachments",
      "duplicate_counts": "{count} Duplicated document | {count} Duplicated documents",
      "expand_document": "Expand document"
    },
    "move": {
      "another_company_description": "Please choose the company the document should be moved to",
      "confirm_footer": "The document will be moved to New documents.",
      "toast_description": "The document was successfully moved to {company}",
      "failed_title": "Document moved to another company failed!",
      "confirm_message_2": "Any unsupported data will be removed during the move. You can review and update the document after it has been moved.",
      "yes_move_item": "Yes, move document",
      "confirm_title": "Move document to",
      "confirm_message_1": "The selected company may not support all fields or journal data from this document.",
      "another_company": "Move document",
      "search_for_company": "Search for a company",
      "toast_title": "Document moved to another company",
      "failed_description": "The document couldn't be moved to {company}",
      "moving_item": "Moving document"
    },
    "fields": {
      "creditor_details": "Creditor details",
      "paymenttype": "Type",
      "swiftbic": "BIC/Swift",
      "bankaccount": "Registration number",
      "currencycode": "Currency",
      "invoiceno": "Invoice number",
      "document_details": "Document details",
      "creditorname": "Creditor",
      "created": "Receive date",
      "duedate": "Due date",
      "creditor_id": "Creditor ID",
      "bankaccountnumber": "Account number",
      "creditor": "Creditor",
      "invoicedate": "Invoice date",
      "taxamount": "VAT amount",
      "payment_details": "Payment details",
      "netamount": "Net amount",
      "vouchernumber": "Voucher number",
      "paymentmethod": "Payment type",
      "documenttype": "Document type",
      "paymentreference": "Payment ID",
      "paymentscheme": "Payment type",
      "creditor_no_and_name": "Creditor",
      "amount": "Amounts",
      "totalamount": "Total amount",
      "paymentcreditor": "Account number",
      "dates": "Dates",
      "internationalswiftbic": "BIC/Swift",
      "fikcode": "Type",
      "domesticbankaccountnumber": "Account number",
      "domesticbankregistrationnumber": "Registration number",
      "fikreference": "Payment ID",
      "fikcreditorid": "Creditor ID",
      "internationaliban": "IBAN number",
      "creditorno": "Creditor number",
      "iban": "IBAN number",
      "reconciliation_account": "Payment account",
      "payment_date": "Payment date"
    },
    "flow_status": {
      "0": "New document",
      "1": "Under review",
      "2": "Cancelled",
      "3": "Declined",
      "4": "Accepted",
      "5": "Waiting",
      "6": "Deleted",
      "7": "Exported",
      "11": "Export failed"
    },
    "forward_to": {
      "state_allready_in_queue": "Already in the flow",
      "state_processed": "Has already processed this document",
      "error": "The document could not be forwarded."
    },
    "document": {
      "validation_mobile_error": "It seems that there are some validation issues present on the document that cannot be solved on mobile."
    },
    "validation": {
      "optional_errors_found": "{count} validation warning has been found in this document | {count} validation warnings has been found in this document",
      "document_has_already_been_exported": "The document has already been exported",
      "due_date_is_outside_allowed_range": "Due date is older than {maximumAgeDays} days",
      "required_item_fields_are_not_filled": "Mandatory fields have not been filled out",
      "payment_fields_do_not_match_creditor_defaults": "Payment details differ from creditor settings",
      "invoice_date_is_before_due_date": "Due date is before invoice date",
      "total_amount_is_not_sum_of_accounting_lines": "The sum of journal entries does not match {amountField}",
      "cost_type_requires_project": "Cost type requires a project",
      "project_requires_cost_type": "Project requires a cost type",
      "required_accounting_lines_are_not_filled": "Mandatory fields on journal entries have not been filled out",
      "condition_execution_failed": "Couldn’t run validation check {validationAction} - {conditionType}",
      "creditor_is_not_active": "Creditor is not active",
      "invoice_date_is_outside_allowed_range": "Invoice date is older than {maximumAgeDays} days",
      "cost_type_is_not_active": "Cost type is not active",
      "yes_i_am_sure": "Yes, I'm sure",
      "errors_found": "{count} validation error has been found | {count} validation errors has been found",
      "net_amount_plus_vat_equals_total_amount": "Net amount plus VAT amount does not equal total amount",
      "payment_fields_validation_failed": "The payment details are not correct",
      "document_is_duplicate": "Document is a duplicate",
      "contra_account_is_not_active": "Contra account is not active",
      "account_is_not_active": "Account is not active",
      "missing_journal_entries": "Missing mandatory journal entry",
      "payment_mismatch_title": "Payment details differ",
      "column_document": "Document",
      "column_field": "Field",
      "payment_mismatch_subtitle": "The payment details on the document differ from the creditor’s saved payment details.",
      "column_creditor": "Creditor",
      "payment_mismatch_helper": "Review the differences before continuing.",
      "empty_value": "-"
    },
    "return": {
      "yes_return": "Yes, return"
    },
    "note": {
      "no_additional_note": "No additional note was provided"
    },
    "action_descriptions": {
      "export_document": "Allows users to export documents from this widget.",
      "send_for_review": "Allows users to send documents for review.",
      "another_company": "Allows users to move documents to another company.",
      "remind_assignees": "Allows users to remind the current assignees.",
      "send_to_exported": "Allows users to move documents to Exported.",
      "return_from_hold": "Allows users to return documents from on hold.",
      "send_to_archive": "Allows users to move documents to Archived",
      "move_document_to": "Groups destinations users can move documents to",
      "edit_voucher_number": "Allows users to edit the document voucher number.",
      "choose_approvers": "Allows users to choose approvers for the document.",
      "move_to": "Groups move-related actions available from this widget.",
      "document_re_export": "Allows users to export documents again.",
      "default": "Controls whether this document action is available in the widget.",
      "change_approvers": "Allows users to change the approvers on the active flow.",
      "edit_flow": "Allows users to edit the active approval flow",
      "approve": "Allows users to approve documents from this widget",
      "on_hold": "Allows users to place documents on hold",
      "document_permanently_delete": "Allows users to permanently delete documents",
      "decline": "Allows users to decline documents from this widget",
      "document_return": "Allows users to return documents to an active widget",
      "delete": "Allows users to delete documents from this widget",
      "change_category": "Allows users to change documents archive categories",
      "another_document": "Allow users to merge a document with another document"
    },
    "meta": {
      "title": "Document",
      "description": "View and process the selected document"
    },
    "access_denied": {
      "description": "It looks like this document is not available to your account. \nIf you think this is a mistake, please contact your administrator",
      "title": "It looks like you don’t have access to view this document"
    },
    "automation": {
      "close": "Close",
      "failed_text": "The automation has failed, check the activity log for more details.",
      "completed_title": "Automations have been completed",
      "completed_text": "{processed}/{total} processed, refresh the page to see updates.",
      "failed_title": "Automation failed",
      "refresh_document": "Refresh document"
    }
  },
  "invitation": {
    "actions": {
      "revoke_invitation": "Revoke invitation",
      "resend_invitation": "Resend invitation"
    },
    "get_to_know_you": {
      "title": "Let's get to know you",
      "subtitle": "Please enter your details",
      "phone_number": "Phone number",
      "full_name": "Full name",
      "saving_your_information": "Continuing",
      "full_name_placeholder": "Please enter your full name",
      "continue_to_password": "Continue and set up password",
      "phone_number_placeholder": "12 34 56 78",
      "search_language": "Search language",
      "language": "Language",
      "account_creation_failed": "We couldn't create your account. Please try again.",
      "country_code": "Country code",
      "select_language": "Please select your preferred language",
      "phone_title": "What's your number?",
      "name_title": "What's your name?",
      "next": "Next",
      "search_country_code": "Search a country code",
      "invalid_phone_number": "Please enter a valid phone number",
      "language_subtitle": "Batchflow will be shown in your selected language",
      "name_subtitle": "Your full name will be shown in Batchflow for your colleagues to see",
      "language_title": "What's your language?",
      "phone_subtitle": "Please provide your country code and your phone number",
      "back": "Back",
      "select_country_code": "Please select your country code",
      "skip_for_now": "Skip for now"
    },
    "revoke_invitation": {
      "warning": "This action will remove the invitation as well as the user from your list.",
      "yes_revoke": "Yes, revoke invitation",
      "title": "Are you sure you want to revoke the invitation to {email}?"
    },
    "twofactor": {
      "lets_set_up_authentication": "Let's set up authentication",
      "twofactor_authentication": "Two-factor authentication",
      "title": "Enhanced security",
      "quick_to_setup": "It's quick to setup. We highly recommend it!",
      "description": "Keep your account safe with Two-Factor Authentication (2FA). Using an app like Microsoft Authenticator adds an extra step to logging in, so even if someone gets your password, they can’t access your account.",
      "set_up_later": "Set up later"
    },
    "expired": {
      "contact_administrator": "Please contact your Administrator for more details.",
      "description": "This can happen if the invitation has been revoked for any reason, has expired, or you have already accepted it.",
      "title": "This invitation no longer exists"
    },
    "resend_invitation": {
      "title": "Are you sure you want to resend the invitation to {email}",
      "yes_resend": "Yes, resend invitation",
      "warning": "This action will send the user a new invitation to Batchflow via email"
    },
    "set_password": {
      "confirm_password_placeholder": "Please confirm your password",
      "password": "Password",
      "password_placeholder": "Enter your password",
      "lets_get_started": "Let's get started",
      "confirm_password": "Confirm password",
      "subtitle": "Please enter a password",
      "setting_your_password": "Getting started",
      "title": "Let's set up your password",
      "account_creation_failed": "We couldn't create your account. Please try again."
    }
  },
  "infobar": {
    "outofoffice": {
      "user_and_delegate": "User {delegate} is delegate for {user}",
      "multible_users": "Multiple users are set as out of office",
      "you_are_delegate": "You are the delegate for {user}",
      "no_delegate": "User {user} is Out of office - no delegate has been set",
      "multiple_users": "Multiple users are out of office"
    },
    "document_state": {
      "read_only": "Read only"
    },
    "automation": {
      "unlock": "Unlock",
      "in_progress": "Automation in progress. {processed}/{total} Processed"
    }
  },
  "integration_errors": {
    "e-conomic": {
      "attachment_file_too_large": "File exceeds the 10 MB maximum allowed by e-conomic."
    }
  },
  "invite_user": {
    "errors": {
      "user_exists_in_selected_companies": "The user already exists in the selected companies"
    }
  },
  "invitaton": {
    "set_password": {
      "subtitle": "Please enter your password"
    }
  },
  "login": {
    "meta": {
      "title": "Log in",
      "description": "Login to your account"
    },
    "password_placeholder": "Enter your password",
    "mfa": {
      "mustenable_title": "Enhanced security",
      "subtitle": "Open your authenticator app and enter the 6-digit code",
      "mustenable_message": "This message means your company's Administrator raised security, requiring two-factor authentication.<br /> <br />Set up an authenticator app like Microsoft Authenticator and pair it with Batchflow.",
      "invalidmfacode": "The code is not valid, please try again",
      "mustenable_button": "Let's set up authentication",
      "verifying": "Verifying",
      "title": "Verify it's you",
      "mustenable_subtitle": "Two-factor authentication",
      "mustenable_bottomtext": "Help to set up two-factor authentication? See {wikilink}",
      "verify": "Verify me",
      "mustenable_description": "Set up two-factor authentication to continue using Batchflow"
    },
    "forgot_password": "Forgot password?",
    "enter_details": "Please enter your login details",
    "password": "Password",
    "email_placeholder": "Enter your email",
    "login": "Log in",
    "errors": {
      "invalid_credentials": "Email or password is not valid, please try again"
    },
    "logging_in": "Logging in",
    "email": "Email",
    "welcome": "Welcome",
    "invalid_credentials": "Email or password is not valid, please try again",
    "remember_me": "Remember me"
  },
  "modals": {
    "comments": {
      "nocomments": "No comments have been added yet",
      "label": "Your comment",
      "send": "Send comment",
      "nocomment_subtext": "Write your comment down below to begin a conversation",
      "header": "Comments",
      "send_executing": "Sending comment",
      "placeholder": "Write your comment here"
    },
    "attachment": {
      "valid_filetypes": "The most common file types are supported",
      "uploading": "Uploading",
      "empty_description": "Uploaded documents will appear here",
      "upload_box_header": "Click to upload or drag and drop",
      "title": "Attachments",
      "unsupported_filetype": "Unsupported file type",
      "file_exceeds_size": "Exceeds size limit of {size} MB",
      "upload_complete": "Upload done ({size})",
      "drop_new_file": "Click to upload or drag and drop a new",
      "cancel_upload": "Cancel",
      "uploaded_documents": "Uploaded documents",
      "empty_title": "No attachments has been uploaded yet...",
      "valid_upload_filesize": "We accept files up to 25 MB"
    },
    "approval_limits": {
      "overall_limit": "Set an overall approval limit",
      "document_type_description": "Set a specific approval limit on documents marked as {documentType}.",
      "amount_placeholder": "Please provide an approval limit",
      "title": "Approval limits",
      "user_description": "Set approval limits for {company}. Amounts are expressed in {currency}.",
      "amount_label": "Approval limit",
      "document_types": "Document types",
      "updating_limits": "Updating limits",
      "overall_description": "Set an overall approval limit that applies to all document types.",
      "description": "Set individual approval limits based on the document types. These approval limits only apply to Stepflows.",
      "update_limits": "Update approval limits",
      "document_specific_description": "Apply different approval limits to each document type",
      "overall_limitation_placeholder": "Please provide an overall approval limitation",
      "document_specific": "Document-specific limits",
      "limitation_types": "Limitation types",
      "overall_limitation_description": "Apply one approval limit to all document types",
      "overall_limitation": "Overall limit",
      "document_specific_helper": "If no limitation is set on the specific document type, they will default back to no limitation.",
      "no_limitation_description": "No approval limit is applied",
      "no_limitation": "Unlimited"
    },
    "admin_activity": {
      "filter_roles": "Roles",
      "filter_miscellaneous": "Miscellaneous",
      "filter_security": "Security",
      "filter_widgets": "Widgets",
      "filter_all": "All",
      "filter_users": "Users",
      "filter_inbound": "Inbound"
    },
    "activity": {
      "filter_flow": "Flow",
      "header": "Activity log",
      "filter_all": "All",
      "filter_batchflow4": "BatchFlow4",
      "filter_match": "Match",
      "empty_description": "There are no log entries found in this filter",
      "empty_header": "No log entries",
      "filter_entries": "Fields",
      "filter_errors": "Errors",
      "filter_journal": "Journal entries"
    },
    "choose_approvers": {
      "choose_from_existing_flows_button": "Choose existing flow",
      "change_approvers": "Change approvers",
      "open_as_default": "Open as default",
      "create_a_one_time_flow": "Create a one-time flow",
      "create_a_one_time_flow_description": "Define a single-use group for this specific approval process",
      "choose_from_existing_flows": "Choose from existing flows",
      "title": "Choose approvers",
      "create_a_one_time_flow_button": "Create one-time flow",
      "choose_from_existing_flows_description": "Use a pre-configured sequence of approvers and flow type",
      "will_open_as_default": "Will open as default"
    },
    "decline_item": {
      "error": "The document could not be declined.",
      "decline": "Decline document",
      "placeholder": "Write your reason here...",
      "label": "Please add the reason for declining the document (this is required)",
      "nevermind": "Cancel",
      "header": "Decline document"
    },
    "duplicate": {
      "active_document": "Active document",
      "button_unique": "Mark as unique",
      "button_delete_title": "Delete active document",
      "action_unique_success_message": "Has marked the following document as unique",
      "button_delete": "Delete active document",
      "action_delete_success_message": "Has marked the following document as a duplicate. The document will be deleted.",
      "button_delete_subtitle": "Marks the active document as a duplicate and deletes it",
      "button_unique_title": "Mark as unique",
      "choose_action": "Choose a duplication action",
      "button_unique_subtitle": "Marks the active document as unique and not a duplicate",
      "found_duplicates": "Duplicates found",
      "header": "Duplicated documents"
    },
    "change_avatar": {
      "saving_avatar": "Saving picture",
      "save_avatar": "Save picture",
      "header": "Change your profile picture"
    },
    "change_workstatus": {
      "title_out_of_office": "Out of office",
      "end_date": "Please pick an end date",
      "end_date_error": "End date must be greater or equal to start date",
      "workstatus": "Work status",
      "title_working": "Working",
      "delegate_type_flow": "Flow",
      "startdate": "Start date",
      "delegate_type_user": "User",
      "choose_delegates": "Choose a delegate for each company",
      "update_work_status": "Change work status",
      "title": "Change work status",
      "choose_timeframe": "Choose a time frame during which you'll be out of the office",
      "saving_work_status": "Changing work status",
      "subtitle_working": "Set your current work status as Working",
      "subtitle_out_of_office": "Set the current work status to Out of office",
      "enddate": "End date (optional)",
      "start_date_error": "Start date must be today or later",
      "delegate_unavailable": "Delegate unavailable",
      "loading_delegate": "Loading delegate..."
    },
    "change_phone_number": {
      "change_phone_number": "Change phone number",
      "header": "Change your phone number",
      "phone_number": "Phone number",
      "phone_number_placeholder": "New phone number",
      "changing_phone_number": "Changing phone number"
    },
    "change_email": {
      "email_description": "We are sending a verification email to your new email address, which must be verified to complete the change",
      "new_email_placeholder": "Please provide a new email",
      "confirm_email": "Confirm new email",
      "confirm_email_placeholder": "Please confirm your new email",
      "new_email": "New email",
      "header": "Change your email",
      "emails": "Emails",
      "change_email": "Change email",
      "changing_email": "Changing email"
    },
    "change_password": {
      "new_password": "New password",
      "confirm_password": "Confirm new password",
      "confirm_password_placeholder": "Please confirm your new password",
      "current_password": "Current password",
      "changing_password": "Changing password",
      "change_password": "Change password",
      "new_password_placeholder": "Please enter your new password",
      "current_password_placeholder": "Please enter your current password",
      "header": "Change your password"
    },
    "change_name": {
      "new_name_placeholder": "Please provide a new name",
      "change_name": "Change name",
      "changing_name": "Changing name",
      "new_name": "New name",
      "header": "Change your name"
    },
    "change_language": {
      "description": "Choose the language used in the interface"
    },
    "create_flow": {
      "create_one_time_flow": "Create a new one-time flow",
      "create_new_flow": "Create a new flow",
      "flow_name": "Name"
    },
    "create_one_time_flow": {
      "title": "Create one-time flow"
    },
    "choose_existing_flow": {
      "title": "Choose approvers",
      "search_empty_title": "No matching approvers",
      "search_empty_description": "We couldn't find a flow or user for that search. Try another name."
    },
    "find_replacement": {
      "each_associated_company": "each associated company",
      "replace_and_remove_user": "Replace and remove user",
      "replace_and_deactivate_user": "Replace and deactivate user",
      "subtitle_flow": "{count} flow, | {count} flows,",
      "subtitle_delegates": "{count} delegate | {count} delegates",
      "subtitle": "{flows} flow and {documents} documents affected",
      "subtitle_docs": "{count} document| {count} documents",
      "replacing_and_deactivation_user": "Deactivating and replacing user",
      "subtitle_post": "affected",
      "title": "Choose a replacement for {company}. This selection will replace {user} in all flows as well as transfer all documents to the replacement.",
      "header": "Find a replacement",
      "replacing_and_removing_user": "Removing and replacing user"
    },
    "invite_new_user": {
      "inviting_user": "Sending invitation",
      "subheader": "Enter the user's email and the language in which the invitation should be sent",
      "companies_header": "Select which companies the user should have access to",
      "invite_user": "Invite user",
      "header": "Invite new user",
      "email": "Email",
      "language": "Language"
    },
    "flow": {
      "change_approval_type": "Change approval type",
      "approvers": "Approvers",
      "applying_approvers": "Applying approvers",
      "details": "Details",
      "required_approvals": "Required approvals",
      "apply_approvers": "Apply approvers",
      "creating_flow": "Creating flow",
      "rules": "Rules",
      "type": "Flow type",
      "forwarding_to": "Forwarding document",
      "delete_flow_profile_confirmation": "Are you sure you wish to delete the flow {flowProfileName}?",
      "forward_to": "Forward document",
      "description": "Description",
      "search_for_approvers": "Search for approvers to add them to the flow",
      "delete_flow_profile_confirmation_warning": "This action will not affect any active flows",
      "create_new_flow": "Create a new flow",
      "remove_approver": "Remove approver",
      "create_new": "Create new flow",
      "create_and_change": "Create flow and change approvers",
      "edit_flow_template_tooltip_description": "Editing the flow will create a one-time flow, using the existing flow as a template",
      "search_for_flow_or_approver": "Search for a flow or name of approvers",
      "no_approvers": "No approvers has been added yet",
      "no_approvers_description": "Search for approvers to add them to the flow",
      "create_and_apply": "Create flow and apply approvers",
      "required_declines": "Required declines",
      "name": "Name",
      "required_approvals_subtitle": "How many people must approve",
      "required_declines_subtitle": "How many people must decline",
      "details_subtitle": "Set the name, type, and description for this flow",
      "rules_subtitle": "Choose how many approvals this flow needs",
      "description_subtitle": "Optional note to help others choose this flow",
      "name_subtitle": "Used in flow lists and when applying this flow",
      "type_subtitle": "Choose a step flow or a multi flow",
      "approvers_subtitle": "Add people who can approve documents in this flow"
    },
    "edit_voucher_number": {
      "toast_success_title": "Voucher number saved",
      "saving": "Saving voucher number",
      "toast_error_title": "Could not save voucher number",
      "pending_text": "{batchflow} is currently pending a voucher number from {erpname}. If a voucher no. is received later, it may replace a manual entry.",
      "missing_text": "No voucher number was returned from {erpname}. You can enter one manually or wait for it to be received automatically.",
      "title": "Edit voucher number",
      "system_text": "This voucher number was received from {erpname} and cannot be edited.",
      "manual_text": "This voucher number was manually edited by {username} and is not synced with {erpname}.",
      "overwrite": "Save voucher number",
      "toast_success_text": "The voucher number was saved successfully.",
      "toast_error_text": "Something went wrong while saving the voucher number"
    },
    "remind_assignees": {
      "last_reminder_sent": "Last reminder sent",
      "remind_assignee": "Are you sure you want to remind",
      "in_list": "in the list?",
      "error_message": "We encountered an error when we tried to send the reminder, please try again later.",
      "already_sent": "{count} assignees were already notified",
      "assignees": "{count} document | {count} documents",
      "has_been_notified": "Has been reminded",
      "remind_all_assignees": "Are you sure you want to send reminders for",
      "this_action": "This action will send a reminder email to all users assigned to review these documents.",
      "remind_assignee_description": "This action will send a reminder email.",
      "nevermind": "Nevermind",
      "has_reminded_assignees": "Has sent reminders for {count} document | Has sent reminders for {count} documents",
      "remind_all": "Remind assignees",
      "has_notified_multiple_users": "Has reminded {count} users on this document"
    },
    "welcomeback": {
      "header": "Welcome back!",
      "footnote": "This action will update your work status in your company.",
      "message": "We can see you've returned during your{newline}Out of office period. {newline}Do you wish to set yourself as working?",
      "set_working": "Yes, update my status"
    },
    "forward_to": {
      "replace": "Replace me",
      "edit_current_flow": "Edit the current flow",
      "title": "Forward to ...",
      "edit_flow": "Edit flow"
    },
    "one_time_approval_limits": {
      "maximum_amount_description": "Set the maximum amount {user} is allowed to approve in this flow."
    },
    "onhold": {
      "comment_placeholder": "Provide additional information",
      "comment_label": "Additional note ({parameter})"
    },
    "loggedout": {
      "subtext1": "Seems like your session has timed out.",
      "subtext2": "You must log in again in order to continue using Batchflow.",
      "to_login_button": "Take me to log in",
      "header": "You have been logged out"
    },
    "general": {
      "no": "Not now",
      "yes": "Yes"
    },
    "invite_user": {
      "please_select_role": "Please select a role"
    },
    "remind_item_assignees": {
      "remind": "Remind"
    },
    "attach_to_another_document": {
      "yes_attach": "Yes, attach document",
      "description": "Select the document you want to attach this document to",
      "confirm_description_2": "This document will be moved to Archived with the category \"Attached to another document\".",
      "title": "Attach to another document",
      "attach": "Attach to document",
      "toast_title": "Document attached",
      "confirm_description_1": "This will attach the current document to the selected document.",
      "confirm_title": "Do you want to attach this document and archive it?",
      "toast_description": "You have successfully attached the document to:"
    }
  },
  "loginmfa": {
    "meta": {
      "description": "Login with Multi-Factor Authentication",
      "title": "Multi-Factor Authentication"
    }
  },
  "languages": {
    "en": "English",
    "da": "Dansk"
  },
  "module": {
    "projects": {
      "name": "Projects",
      "description": "Manage projects in Batchflow"
    },
    "departments": {
      "description": "Manage departments in Batchflow",
      "name": "Departments"
    }
  },
  "notifications": {
    "list": {
      "mark_all_as_read": "Mark all as read",
      "empty_title": "We couldn't find any notifications",
      "unread": "Unread ({count})",
      "empty_description": "Check All to view your previous notifications...",
      "unread_empty_title": "You have no unread notifications",
      "all_unread_for_30_days": "That's all your unread notifications for the last 30 days",
      "all": "All",
      "mark_all_as_unread": "Mark all as unread",
      "all_for_30_days": "That's all your notifications for the last 30 days"
    },
    "reminder": {
      "multiple_documents": "Has reminded you that you have {count} documents pending review.",
      "notified_multiple_users_text": "You have reminded {count} user on this document. | You have reminded {count} users on this document.",
      "already_notified": "Users on {count} document have already been notified | Users on {count} documents were already notified",
      "single_document": "Has reminded you of a document pending review.",
      "notified_multiple_users_header": "User has been reminded | Users have been reminded",
      "notified_multiple_users_on_multiple_documents_text": "You have reminded users on {count} document. | You have reminded users on {count} documents.",
      "notified_multiple_users_on_multiple_documents_header": "Users have been reminded"
    },
    "change_email": {
      "email_verification_sent_to_mail": "We've sent a verification email to {email}. \nPlease confirm it to start using your new email address.",
      "mail_change_verification_sent": "Email change verification sent",
      "please_log_in_using_new_email": "Please log in using your new email to continue working in Batchflow.",
      "your_email_has_been_changed": "Your email has been changed"
    },
    "flow": {
      "canceled_header": "Review was cancelled",
      "flow_updated_description": "You have successfully updated {flowProfileName}",
      "flow_updated": "{flowProfileName} has been updated",
      "you_have_been_added_to_queue": "Has added you to the review process for a document.",
      "flow_deleted_description": "You have successfully deleted the flow",
      "removed_from_queue": "Has cancelled the review for this document, and you will be removed from the review process.",
      "flow_deleted": "Flow has been deleted",
      "canceled_message": "The review was cancelled for this document, and the user in the flow has been notified. | The review was cancelled for this document, and the users in the flow have been notified."
    },
    "deactivate_user_badge_companies": "{count} companies",
    "organisation": {
      "you_have_saved_security_settings": "You have saved security settings for your organization",
      "you_have_saved_miscellaneous_settings": "You have saved miscellaneous settings for your organization",
      "organisation_saved_settings": "Settings saved"
    },
    "change_avatar": {
      "file_too_large": "Your file is too large",
      "error_reading_file_description": "Your image is either corrupt or unavailable. Please try again",
      "file_too_large_description": "Your file is too large and exceeds the 10 MB limit – please find a smaller one.",
      "invalid_file_type": "Wrong file type",
      "success": "Your avatar has been updated",
      "error_reading_file": "We had trouble loading your image",
      "success_description": "Your avatar has successfully been updated",
      "invalid_file_type_description": "Please upload an image of any type"
    },
    "replace_user": {
      "message_flow": "{count} flow | {count} flows",
      "header": "User was removed from company",
      "message_docs": "{count} document | {count} documents",
      "message_updated": "has been updated",
      "no_changes": "No flows or documents was changed",
      "multi_companies": "multiple companies"
    },
    "invitation": {
      "invitation_resent": "Invitation has been resent",
      "invitation_sent": "Invitation has been sent",
      "invitation_revoked": "Invitation has been revoked",
      "sent_to_email": "You have sent an invitation to {email}",
      "resent_to_email": "You have resent an invitation to {email}",
      "has_joined_your_organization": "Has joined your organization",
      "revoked_invitation_to_mail": "You have revoked the invitation to {email}",
      "invitation_error": "The invitation could not be sent. Try again.",
      "error": "Invitation failed"
    },
    "deactivate_user": {
      "header": "User has been deactivated"
    },
    "altered_assigned_document": {
      "put_on_hold": "Has put a document you're assigned to On hold."
    },
    "export": {
      "text": "You have successfully exported the following document",
      "header": "Document exported"
    },
    "export_text": "You have exported the following document:",
    "assigned_you_to_documents": "Has assigned you to {count} documents | Has assigned you to {count} document",
    "change_phone_number": {
      "you_have_successfully_changed_your_phone_number": "You have successfully changed your phone number",
      "phone_number_has_been_changed": "Phone number has been changed"
    },
    "decline": {
      "header": "Document declined",
      "text": "You have declined the following document."
    },
    "password": {
      "password_updated": "Password has been changed",
      "you_have_successfully_updated_your_password": "You have successfully changed your password"
    },
    "change_name": {
      "you_have_successfully_changed_your_name": "You have successfully changed your name",
      "name_has_been_changed": "Name has been changed"
    },
    "general": {
      "something_went_wrong": "Something went wrong...",
      "something_went_wrong_description": "Something went wrong. Try again."
    },
    "duplicate": {
      "mark_as_duplicate_text": "You've marked the document as a duplicate. \nThe document will be deleted.",
      "mark_as_unique_text": "You've marked the following document as unique.",
      "mark_as_unique_header": "Document marked as unique",
      "mark_as_duplicate_header": "Document marked as duplicate"
    },
    "approve": {
      "header": "Document approved",
      "text": "You have approved the following document."
    },
    "assigned_you_to_flows": "Has assigned you to {count} flows| Has assigned you to {count} flow",
    "title": "Notifications",
    "work_status_changed": "Has updated their current work status from {oldStatus} to {newStatus}",
    "go_to_document": "Go to document | Go to documents",
    "error_deactivate_user": {
      "header": "Couldn't deactivate user in {company}"
    },
    "widget": {
      "widget_saved": "{widget} has been saved",
      "you_have_saved_widget": "You have successfully saved changes to {widget}"
    },
    "review": {
      "send_for_review_text": "The document was sent for review to the approver in the selected flow. | The document was sent for review to the approvers in the selected flow.",
      "user_added_to_review_process": "Has added you to the review process for a document.",
      "send_for_review_header": "Document sent for review"
    },
    "userrole": {
      "you_have_changed_userrole_header": "Permission for {user} was saved",
      "you_have_changed_userrole": "You have changed the role to {role}"
    },
    "work_status": {
      "you_have_updated_your_work_status": "You have successfully updated your work status from {fromState} to {toState}.",
      "user_work_status_updated": "You have successfully updated {user}'s work status from {fromState} to {toState}.",
      "your_work_status_updated": "Your work status has been updated",
      "you_have_updated_user_work_status": "Work status has been updated"
    },
    "role": {
      "role_saved": "{role} has been saved",
      "you_have_saved_role": "You have successfully saved changes to {role}"
    },
    "two_factor": {
      "two_factor_authentication_was_changed": "Two-factor authentication has been changed",
      "two_factor_authentication_was_removed_from_account": "You have successfully removed Two-factor authentication from your account"
    },
    "replace_user_error": {
      "sub_message_single": "{company} could not be removed.",
      "sub_message": "Something went wrong, please try again.",
      "header": "Something went wrong ... Try again"
    },
    "userwork": {
      "you_have_updated_user_work_status": "Work status has been updated"
    }
  },
  "navigation": {
    "documents": "Documents",
    "archive": "Archive",
    "notifications": "Notifications",
    "profile": "Profile",
    "hold": "Hold"
  },
  "moodal": {
    "userpermission": {
      "user_details": "User details",
      "update_permission": "Update permissions",
      "header": "User permissions",
      "updating_permission": "Updating permissions"
    }
  },
  "notification": {
    "user_disabled": {
      "title": "Your access to Batchflow has been revoked",
      "body": "Please contact your Administrator for more details."
    },
    "subtitle": "Please select which action you wish to perform on your notifications"
  },
  "multi_selector": {
    "deselect_documents": "Deselect document | Deselect documents",
    "documents_selected": "{count} document | {count} documents",
    "selected": "selected"
  },
  "note_popup": {
    "no_comments": "No comments",
    "hover_text_start_new": "Start conversation",
    "total_replies": "replies",
    "hover_text": "Go to conversation"
  },
  "pdf": {
    "document_details": {
      "flow_changed": "Flow changed",
      "creditor_and_creditor_no": "Creditor",
      "received": "Received",
      "user": "User",
      "batchflow_id": "Batchflow ID",
      "date": "Date",
      "export_date": "Export date",
      "invoice_no": "Invoice number",
      "approved": "Approved",
      "comments": "Comments",
      "email": "Email",
      "decline": "Decline(s)",
      "reason": "Reason",
      "view_invoice_in_batchflow": "View invoice in Batchflow",
      "approval_summary": "Approval summary",
      "approval": "Approval(s)",
      "export_details": "Export details",
      "action": "Action",
      "flow_started": "Flow started",
      "comment": "Comment",
      "declined": "Declined"
    },
    "layout": {
      "of": "of",
      "page": "Page",
      "generated_by": "Generated by",
      "document_title": "ERP Export document",
      "document_subtitle": "Invoice, summary, and attachments"
    },
    "sections": {
      "section_subtitle_invoice": "Original document",
      "section_document_details": "Document details",
      "section_attachments": "Attachments",
      "section_invoice": "Document",
      "section_subtitle_attachments": "Attachments to the document"
    }
  },
  "note": {
    "date": {
      "days": "{days} days ago",
      "today": "Today {time}"
    }
  },
  "pdf_viewer": {
    "expand_view": "Expand view",
    "cannot_preview_file": "Cannot preview this file",
    "e_invoice": "e-Invoice",
    "download_to_preview": "Download the file to preview",
    "move": "Move",
    "zoom_in": "Zoom in",
    "select": "Select text",
    "next_page": "Next page",
    "show": {
      "as_pdf": "Show as PDF",
      "as_e_invoice": "Show as e-Invoice"
    },
    "view": "View as",
    "page_of": "{pageNum} of {totalPages}",
    "pdf": "PDF",
    "empty": {
      "header": "The document couldn't be found",
      "subheader": "We searched thoroughly, but we couldn't find anything"
    },
    "zoom_to_fit": "Fit to width",
    "previous_page": "Previous page",
    "zoom_out": "Zoom out",
    "pop_out": "Pop out",
    "popout": {
      "empty": "Open an invoice to display it.",
      "show_here": "Show here",
      "elsewhere": "The document is shown in another window.",
      "empty_title": "No invoice selected"
    }
  },
  "page": {
    "errors": {
      "404": "Lost in the ledger...",
      "500": "Something broke...",
      "500_description": "It seems like we are experiencing some technical difficulties at the moment. \nIf the problem persists, please contact our Support.",
      "error": "Error {code}",
      "404_description": "Seems like the page has been filed in the wrong drawer.\nDouble check the URL or return to the homepage"
    }
  },
  "origination": {
    "change": {
      "message": "Organization changed"
    }
  },
  "onhold": {
    "modal": {
      "execute": "Place on hold",
      "subtitle": "Choose the reason for placing the document on hold",
      "nevermind": "Nevermind",
      "title": "Place invoice on hold"
    },
    "reason_choice": {
      "missing_documentation": "Required documents are missing",
      "test_3": "A Great Reason",
      "goods_or_services_not_received": "Goods or services were not received",
      "test_4": "Well, it's a reason...",
      "test_1": "A Slightly Greater Reason",
      "credit_note_await": "Awaiting Credit Note",
      "test_2": "A Not So Great Reason"
    },
    "reason": {
      "1": "Awaiting credit note"
    }
  },
  "outbound": {
    "title": "Outbound",
    "empty": {
      "exporting_documents_appear_here": "Documents that are currently being exported will appear here.",
      "looking_for_documents_or_export_errors": "Looking for exported documents or export errors? You can find them below.",
      "view_exported_documents": "View exported documents",
      "view_export_errors": "View export errors"
    },
    "description": "View and manage outbound documents"
  },
  "organisation": {
    "companies": "{count} company | {count} companies",
    "working_from": "Working from",
    "setting": {
      "apply": "Apply"
    }
  },
  "pagination": {
    "showing": "Showing",
    "of": "of"
  },
  "pdf_file": {
    "download": {
      "message": "This might take a few moments...",
      "title": "Getting your PDF ready",
      "error_message": "The PDF file could not be downloaded. Try again.",
      "missing_data": "No PDF file is available for this document.",
      "error_title": "PDF download failed"
    }
  },
  "organisations": {
    "header": "Organizations",
    "subheader": "Select an organization"
  },
  "project": {
    "fields": {
      "coresponsibleemployeenumber": "Co-owner",
      "responsibleemployeenumber": "Owner",
      "projectnumbe": "Project number",
      "description": "Description",
      "active": "Status",
      "customernumber": "Customer number",
      "projectnumber": "Project number"
    }
  },
  "permissions": {
    "setting_journal": "Edit journal entries",
    "setting_company_document_fields_description": "Allows users to view or edit the document fields",
    "setting_company_settings_description": "Allow users to manage company-wide defaults and export behavior within the specific company",
    "setting_company_validations_description": "Allow users to manage company settings",
    "setting_company_journals_description": "Allow users to manage journal entry templates within the specific company",
    "setting_company_settings": "Company settings",
    "setting_admin_inbound_description": "Allow users to manage the settings for the inbound feature",
    "setting_company_creditor": "Creditors",
    "setting_company_flows": "Flows",
    "setting_allow_user_invite_description": "Allows the user to invite new users to the company within Batchflow",
    "setting_company_addons_projects": "Manage owners",
    "setting_company_automations": "Automations",
    "setting_company_flow_edit": "Allow editing of Flows",
    "setting_admin_widget": "Widgets",
    "setting_company_automations_description": "Allow users to manage automations within the specific company",
    "setting_journal_edit": "Edit journal entries",
    "setting_admin_user": "Users",
    "setting_journal_read_description": "Allows the view of journal entries",
    "setting_admin_inbound": "Inbound",
    "setting_admin_edit": "Allow to edit administrative information ",
    "setting_company_invite_user": "Allow invitation of users",
    "setting_company_creditor_description": "Allow users to manage the creditors within the specific company",
    "settings_company_addons_projects_description": "Allow users to view or edit the owners",
    "setting_admin_user_description": "Allow users to invite and manage the users within the organization",
    "setting_allow_user_invite": "Allow to invite users to Batchflow",
    "setting_admin_role": "Roles",
    "setting_admin_security_description": "Allow users to manage the security within the organization",
    "setting_journal_read": "See journal entries",
    "setting_company_flow_edit_description": "Allow users to manage the flows within the specific company",
    "setting_admin_role_description": "Allow users to manage the roles within the organization",
    "setting_approval_limits_description": "Allow users to view and edit approval limits",
    "setting_company_invite_user_description": "Allow users to invite new users to a specific company",
    "setting_admin_edit_description": "Allows the user to make changes to users within the company",
    "setting_company_flows_description": "Allow users to manage flows within the specific company",
    "setting_company_validations": "Company settings",
    "setting_document_fields": "Edit document fields",
    "setting_approval_limits": "Approval limits",
    "not_set": "Not set",
    "setting_journal_edit_description": "Allow users to work with journal entries",
    "setting_admin_widget_description": "Allow users to manage the widgets within the organization",
    "setting_company_journals": "Allow editing of Journal entry templates",
    "setting_journal_description": "Allows users to work with journal entries\n",
    "setting_admin_security": "Security"
  },
  "projects": {
    "employee_mapping": {
      "no_mapping_issues_found": "We found no issues with links between owners and users",
      "please_verify": "Verify user",
      "no_employees_found": "No owner found",
      "browse_batchflow_users": "Find a Batchflow user to link to",
      "search_for_a_user": "Search for a name or an email",
      "not_found": "No user found",
      "filter_employees": "Filter owners",
      "show_all": "Show all",
      "please_ensure_correct_mapping": "Please ensure owners are linked to the correct users",
      "unmap_user": "Remove link",
      "title": "Manage owners",
      "select_employee": "Link user",
      "choose_a_user_to_match": "Choose the user to link to the owner",
      "no_email_found": "No email found",
      "erp_user_id": "ERP ID:",
      "issues_regarding_mapping_appear_here": "Potential linking issues are shown here",
      "show_mapping_issues": "Show linking issues",
      "find_employee": "Link user",
      "employees_are_imported_from_erp": "Owners are imported from your ERP system, have you created any?",
      "verify_all": "Verify all",
      "verify": "Verify",
      "verified": "Verified",
      "update_mappings": "Apply links",
      "linked": "Linked"
    },
    "columns": {
      "projectnumber": "Project number",
      "name": "Name",
      "co_responsible_employee": "Co-owner",
      "responsible_employee": "Owner",
      "description": "Description",
      "status": "Status"
    },
    "employee": {
      "linked_to": "Linked to",
      "no_user_linked": "No link has been found"
    },
    "employees_mapping": {
      "mappings_updated_title": "Updated {count} employee | Updated {count} employees",
      "mappings_updated": "Employee mappings have been updated"
    },
    "buttons": {
      "manage_project_owners": "Manage owners",
      "manage_columns": "Manage columns"
    },
    "search_and_filter": "Search",
    "manage_columns": {
      "columns_updated": "Journal entry columns have been updated",
      "columns_updated_title": "Updated columns",
      "title": "Manage columns",
      "description": "Please choose which project columns should be available in journal entries",
      "update_columns": "Apply columns"
    },
    "search_empty": {
      "subheader": "All of your projects will be shown here once they've been imported...",
      "header": "Couldn't find any projects"
    }
  },
  "popup": {
    "onhold_reason": {
      "no_additional_note": "No additional note"
    }
  },
  "profile": {
    "title": "Profile",
    "description": "View and manage your profile"
  },
  "permission": {
    "setting_approval_limits": "Approval limits"
  },
  "resetpassword": {
    "validation": {
      "upperlower": "Upper & lower case letters",
      "nonalfa": "A symbol (e.g. #&%)",
      "length": "8 characters long",
      "title": "Create a secure password",
      "numeric": "A number"
    },
    "confirm_password": "Confirm Password",
    "invalid_token_header": "Time's up...",
    "password_mismatch": "Passwords does not match",
    "invalid_token": "The password reset link has expired",
    "error_title": "It's not you, it's us",
    "invalid_token_message": "The password reset link you received in the email has expired or was already used, it can only be clicked once.<br/><br/>We can resend a new link to your email:<br/><b>{email}</b><br/><br/>If you did do not receive an email, please try to reset your password again or contact our Support Team.",
    "title": "Reset password",
    "reset_error_header": "Something went wrong...",
    "resend": "Resend email",
    "reset": "Update password",
    "error": {
      "password_validation_empty": "Password is required",
      "reset_failed": "Password reset failed. Please try again.",
      "password_not_meets_criteria": "Your new password isn't quite strong enough. Make sure it meets all four criteria"
    },
    "success_message": "Your password has been updated and can now be used to access Batchflow.",
    "success_title": "Password has been updated",
    "new_password": "New password",
    "meta": {
      "description": "Reset your password",
      "title": "Reset password"
    },
    "new_password_placeholder": "Enter your new password",
    "error_message": "It seems like we are experiencing some technical difficulties at the moment.<br/><br/>If the problem persists, please contact our Support Team.",
    "back": "Return to login",
    "confirm_password_placeholder": "Re-enter your new password",
    "resetting": "Updating password",
    "password_validation_error": "Your new password isn't quite strong enough. Make sure it meets all four criteria",
    "sub_title": "For the account <b>{email}</b>"
  },
  "settings": {
    "company_settings": {
      "attachment_export_settings_description": "Choose what happens if attachments can’t be exported to the ERP",
      "amount_validation_field_description": "Balances accounting lines against the total or net amount",
      "default_currency": "Default currency",
      "company_wide_settings_description": "General settings for {company}",
      "amount_validation_field_warning_body": "Changing this can make historical documents look inconsistent because existing accounting lines may have been balanced against the previous field.",
      "company_timezone_description": "Used for timestamps and exports",
      "amount_validation_field": "Accounting amount field",
      "amount_validation_field_net_amount": "Net amount",
      "approval_controls": "Approval controls",
      "attachment_export_settings": "On attachment error",
      "accounting_controls": "Posting rules",
      "company_timezone": "Timezone",
      "amount_validation_field_total_amount": "Total amount",
      "amount_validation_field_warning_title": "Change accounting amount field?",
      "default_currency_description": "Used for documents, approvals, and reporting",
      "amount_validation_field_warning_confirm": "Change field",
      "company_wide_settings": "Company settings",
      "move_to_export_errors": "Move to Export errors",
      "maximum_allowed_accounting_difference_description": "Small differences below this amount are automatically accepted during posting",
      "force_export": "Export without attachments",
      "financial_defaults": "Financial settings",
      "maximum_allowed_accounting_difference": "Allowed difference",
      "move_to_export_errors_description": "Stops the export and moves the document to Export errors",
      "export_attachment": "Attachment export",
      "export_timestamp_format": "Export timestamp format",
      "inherit_approval_limits_when_out_of_office": "Delegates inherit approval limits",
      "export_timestamp_format_description": "Timestamps are automatically added to exported document file names",
      "export_timestamp_format_title": "Export timestamp format",
      "default_language": "Default language",
      "default_language_description": "Language used for communication and generated documents",
      "failed_to_save_toast": "Failed to save company settings",
      "force_export_description": "Continues the export without attachments",
      "page_description": "Manage general settings in your company",
      "localization": "Regional settings",
      "inherit_approval_limits_when_out_of_office_description": "Delegates use the amount limit of the user they are acting on behalf of",
      "saved_toast": "Company settings saved",
      "title": "Company settings",
      "failed_to_save_message": "An unexpected error occurred while saving company settings.",
      "payment_type_international": "IBAN",
      "payment_information_source": "Use payment details from",
      "payment_information_source_invoice": "Document",
      "payment_information_source_creditor": "Creditor",
      "payment_type_none": "None",
      "payment_type_fik": "FIK",
      "payment_type_bank": "Bank account",
      "payment_type_order_description": "Used when several payment types are captured on a document",
      "payment_type_order": "Preferred payment type order",
      "payment_information_source_invoice_description": "Use what was captured on the invoice. Changing creditor does not change the payment details",
      "payment_information": "Payment details",
      "payment_information_source_creditor_description": "Use the payment details saved on the creditor. Changing creditor updates the payment details",
      "auto_approve_previously_approved_documents": "Auto-approve previously approved documents",
      "auto_approve_previously_approved_documents_description": "If an invoice is sent to the same user again, it is auto-approved if they approved it before, validations are optional, and the flow has 2+ users",
      "payment_information_source_description": "Choose whether payment details should follow the creditor or the individual document",
      "reconciliation_accounts_description": "Choose the accounts that can be used for Posting only",
      "payment_type_order_reset": "Restore default order",
      "reconciliation_accounts": "Payment accounts",
      "search_for_reconciliation_accounts_to_add": "Search for accounts above to add them",
      "add_reconciliation_account": "Add payment account",
      "remove_reconciliation_account": "Remove payment account",
      "no_reconciliation_accounts_added_yet": "No payments accounts added yet"
    },
    "company_specific_settings": "Company settings",
    "header": "Settings",
    "inactive": "Inactive",
    "company": {
      "manage_company_settings": "Manage company settings"
    },
    "subheader": "Manage your organization's users, roles and other settings",
    "global_settings": "Global settings",
    "activated": "Activated",
    "miscellaneous": {
      "title": "Miscellaneous",
      "onhold_mandatory_additional_note_description": "Make it mandatory for users to add an additional note when setting a document On hold",
      "description": "Description",
      "subtitle": "Manage miscellaneous settings in your organization",
      "miscellaneous_description": "View and manage the miscellaneous settings in your organization",
      "onhold_group_title": "On hold",
      "onhold_group_description": "Set preferences for On hold",
      "onhold_mandatory_additional_note_title": "Mandatory additional note"
    },
    "log_button": {
      "settings_tooltip": "Global settings log",
      "flow_tooltip": "Flow log",
      "security_tooltip": "Security log",
      "roles_tooltip": "Roles log",
      "widgets_tooltip": "Widgets log",
      "role_tooltip": "Role log",
      "flows_tooltip": "Flows log",
      "automation_tooltip": "Automation log",
      "users_tooltip": "Users log",
      "user_tooltip": "User log",
      "widget_tooltip": "Widget log",
      "projects_tooltip": "Projects log",
      "inbound_tooltip": "Inbound log",
      "miscellaneous_tooltip": "Miscellaneous log",
      "automations_tooltip": "Automations log",
      "tenant-oauth_tooltip": "API access log",
      "validations_tooltip": "Validations log",
      "tenant_tooltip": "Company settings log"
    },
    "oauth": {
      "client_created": "OAuth client created",
      "loading_scopes": "Loading scopes",
      "client_created_description": "The client secret is shown once. Store it before leaving this page.",
      "clients": "OAuth clients",
      "create_new_client": "Create new client",
      "create_credentials": "Create credentials",
      "created_credentials": "Created credentials",
      "client_name_placeholder": "External reporting service",
      "back_to_clients": "Back to clients",
      "intro_description": "Create OAuth credentials for {company}.",
      "copied_description": "The value was copied to the clipboard.",
      "copy": "Copy",
      "copy_client_id": "Copy client ID",
      "description": "Description",
      "clear_scopes": "Clear",
      "no_clients_description": "Create a client to get a client ID and one-time client secret for external API usage.",
      "client_secret_notice": "The secret is only visible now. It cannot be recovered later.",
      "client_secret": "Client secret",
      "creating_client": "Creating credentials",
      "create_client_description": "Choose a client name and the API scopes this credential can use.",
      "create_client": "Create OAuth client",
      "no_clients": "No OAuth clients created",
      "description_placeholder": "Where this credential will be used",
      "client_name": "Client name",
      "created_credentials_description": "Copy these values now. The client secret is only returned once.",
      "copied": "Copied",
      "intro_title": "OAuth credentials",
      "client_id": "Client ID",
      "scope_default_action": "Access",
      "scopes": "Scopes",
      "scope_count": "{count} scope | {count} scopes",
      "scope_delete_action": "Delete",
      "scope_read_description": "Allows reading {resource}",
      "select_all_scopes": "All scopes",
      "title": "API access",
      "scope_write_action": "Write",
      "scope_delete_description": "Allows deleting {resource}",
      "page_description": "Create OAuth credentials for this company",
      "select_read_scopes": "Read scopes",
      "no_scopes": "No scopes are available",
      "scope_default_description": "Allows access to {resource}",
      "no_client_scopes": "No scopes",
      "scope_write_description": "Allows creating or updating {resource}",
      "scopes_description": "Scopes control which API areas the client can access.",
      "scope_read_action": "Read",
      "clients_description": "View OAuth credentials created for {company}",
      "create_failed": "The OAuth client could not be created"
    },
    "inbound": {
      "copy_email": "Copy email",
      "emails_title": "Inbound emails",
      "emails_subtitle": "View how Batchflow receives and processes incoming documents.",
      "title": "Inbound",
      "subtitle": "Manage inbound settings in your organization",
      "description": "View and manage inbound settings",
      "registration_receiver_id": "Receiver ID: {receiver}",
      "registrations_empty": "No e-Invoice registrations are available.",
      "registration_gln_ean_number": "GLN/EAN number: {receiver}",
      "registration_unclassified": "Unclassified",
      "registrations_title": "e-Invoice registrations",
      "registrations_subtitle": "View registered CVR and GLN/EAN numbers used to receive electronic invoices through BatchFlow",
      "registration_vat_number": "VAT number: {receiver}"
    },
    "general": {
      "saving_changes": "Saving changes",
      "revert_changes": "Revert changes",
      "save_changes": "Save changes",
      "create_template": "Create template"
    },
    "flow_profiles": {
      "required_approvals": "Required approvals",
      "required_declines": "Required declines"
    },
    "roles": {
      "journal_entries_edit_subtitle": "Allow users to work with journal entries",
      "approval_permissions_subtitle": "Activate approval permissions and grant the role access to view them",
      "document_fields_subtitle": "Settings which apply to the document fields of Batchflow",
      "company_settings_subtitle": "Activate Company settings and grant the role access to view them",
      "journal_entries_header": "Journal entries",
      "admin_settings_invite_user_subtitle": "Allows the user to invite new users to the company within Batchflow",
      "admin_settings_header": "Global settings",
      "company_addons_projects_subtitle": "Activate the projects expansion and grant the role access to view them",
      "admin_settings_edit_header": "Allow to edit administrative information ",
      "admin_settings_subtitle": "Activate Global Settings and grant the role access to view them",
      "document_fields_header": "Document fields",
      "admin_settings_see_subtitle": "Allows the user to see administrative information within the company",
      "admin_settings_see_header": "Allow to see administrative information",
      "archive_widgets_header": "Archive",
      "journal_entries_see_header": "See journal entries",
      "widgets_header": "Widgets",
      "admin_settings_invite_user_header": "Allow to invite users to Batchflow",
      "approval_permissions_header": "Approval permissions",
      "title": "Roles",
      "role_description": "Description",
      "admin_settings_edit_subtitle": "Allows the user to make changes to users within the company",
      "archive_widgets_subtitle": "Select which archives are visible for the role",
      "journal_entries_edit_header": "Edit journal entries",
      "company_settings_header": "Company settings",
      "journal_entries_see_subtitle": "Allows the view of journal entries",
      "widgets_subtitle": "Select which widgets are visible for this role",
      "company_addons_projects_header": "Projects",
      "description": "View and manage roles",
      "journal_entries_subtitle": "Enable journal entries for this widget",
      "admin_settings_activation": "Enable global settings",
      "document_fields_enable_subtitle": "Enable document fields for this widget",
      "document_fields_activation": "Enable document fields",
      "approval_permissions_activation": "Enable approval permissions",
      "company_settings_activation": "Enable company settings",
      "company_addons_projects_activation": "Enable projects",
      "journal_entries_activation": "Enable journal entries"
    },
    "users": {
      "activating_user": "Activating user",
      "change_language": "Change language",
      "are_you_sure_request_password_reset": "Are you sure you wish to request a password reset?",
      "activate": "Activate user",
      "change_email": "Change email",
      "activating_user_consequences": "By activating the user now has access to login in to BatchFlow",
      "change_language_title": "Language",
      "activate_user": "Activate user",
      "change_avatar": "Upload image",
      "action_will_request_password_reset": "This action will send a password reset email to {email}",
      "change_name": "Change name",
      "avatar": "Avatar",
      "avatar_description": "Upload or change your profile image",
      "change_password_description": "Change your password",
      "send_user_password_reset": "Send the user a request to reset their password",
      "password_reset_request_sent": "Password reset request has been sent",
      "password_request_sent_to": "You have sent a password reset request email to {username}",
      "invite_new_user": "Invite new user",
      "view_permissions": "View permissions",
      "set_up_two_factor_authentication": "Set up 2FA",
      "two_factor_is_required_description": "You are a member of an organization that has required users to use Two-factor authentication for their account security",
      "whereabouts": "Out of Office",
      "edit_whereabouts": "Change work status",
      "not_working": "Not working",
      "full_name": "Full name",
      "phone": "Phone number",
      "deactivate_user": "Deactivate user",
      "change_phone_number": "Change phone number",
      "enable_two_factor_authentication": "Keep your account safe with Two-factor authentication (2FA)",
      "set_yourself_out_of_office": "Set yourself as Out of office",
      "security_and_whereabouts": "Personal settings",
      "deactivate": "Deactivate user",
      "password_reset": "Reset password",
      "working": "Working",
      "title": "Users",
      "out_of_office": "Out of office",
      "preparing_to_invite_user": "Inviting new user",
      "companies_header": "Companies",
      "two_factor_is_required": "Two-Factor is required",
      "pending_invite": "Invite pending",
      "email": "Email",
      "two_factor_authentication": "Two-factor authentication",
      "companies_in_total": "{count} company | {count} companies in total",
      "pending": "Pending",
      "companies": "Companies",
      "change_work_status": "Change work status",
      "request_password_reset": "Request password reset",
      "expired_invite": "Invite expired",
      "update_users_whereabouts": "Set the user out of office",
      "subtitle": "Manage users in your organization",
      "deactivating_user": "Deactivating user",
      "yes_request_password_reset": "Yes, request password reset",
      "deactivating_user_consequences": "Deactivating the user will lock them out of Batchflow",
      "edit_two_factor_authentication": "Edit 2FA",
      "password_title": "Password",
      "user_information": "Personal information",
      "change_organisation_change": "Change organization",
      "change_password": "Change password",
      "description": "View and manage users",
      "disable_two_factor": "Disable 2FA",
      "disable_two_factor_title": "Disable 2FA?",
      "yes_remove": "Yes, remove",
      "yes_remove_two_factor": "Yes, deactivate 2FA",
      "disable_two_factor_confirmation": "This will remove two-factor authentication for {name}. \nThey can set it up again at any time.",
      "layout_style_description": "Choose a standard or compact layout",
      "view_layout_standard": "Standard",
      "view_layout_compact": "Compact",
      "layout_style": "Layout style"
    },
    "tenant": {
      "automations_subtitle": "Manage automations in your company",
      "my_addons": "My expansions",
      "journal_entries_subtitle": "Manage the journal entry templates in your company",
      "creditors_subtitle": "Manage the creditors in your company",
      "projects": "Projects",
      "automations": "Automations",
      "manage": "Settings",
      "creditors": "Creditors",
      "company_settings": "Company settings",
      "oauth_subtitle": "Create OAuth credentials for this company",
      "validations_subtitle": "Manage validations in your company",
      "flows_subtitle": "Manage flows in your company",
      "journal_entries": "Journal entry templates",
      "flows": "Flows",
      "invite_user": "Invite user",
      "additional_modules": "Additional expansions",
      "company_settings_subtitle": "Manage general settings in your company",
      "subtitle": "Manage your company's settings and add-ons",
      "invite_user_subtitle": "Invite new user to your company",
      "oauth": "API access",
      "validations": "Validations",
      "automations_description": "Manage automations for this company",
      "flows_description": "Manage flows for this company",
      "validations_description": "Manage validations for this company",
      "projects_description": "Manage projects for this company",
      "creditors_description": "Manage creditors for this company",
      "journal_entries_title": "Journal entries",
      "journal_entry_subtitle": "Manage journal entry templates in you company\n",
      "departments_description": "Manage departments for this company",
      "departments": "Departments",
      "email_notifications": "Email notifications",
      "email_notifications_subtitle": "View and manage email notification settings"
    },
    "user": {
      "remove_two_factor_confirmation": "Are you sure you wish to remove Two-factor authentication for your account?",
      "organisation_description": "Please select which organization you wish to work from",
      "you_can_always_enable_it_again": "You can always setup Two-factor authentication again",
      "remove_two_factor": "Remove two-factor authentication?",
      "organisation_name": "Organisation"
    },
    "security": {
      "security_description": "View and manage the security in your organization",
      "authentication_description": "Settings which apply to the login section of Batchflow",
      "mandatory_two_factor_description": "Make it mandatory for users to use an authenticator app when logging in",
      "title": "Security",
      "authentication": "Authentication",
      "description": "Description",
      "subtitle": "Manage security in your organization",
      "mandatory_two_factor": "Mandatory Two-factor authentication (2FA)"
    },
    "permissions": {
      "can_view": "Can view",
      "can_edit": "Can edit",
      "can_edit_description": "Users are able to view and edit",
      "can_view_description": "Users are only able to view",
      "disabled": "Disabled",
      "disabled_description": "Users will not be able to view or edit"
    },
    "validations": {
      "copy_search_placeholder": "Search validations",
      "copy_no_results_title": "No matching validations",
      "copy_existing_validations_title": "Copy existing validations",
      "add_validation": "Add validation",
      "continue": "Continue",
      "add_dependency_submit": "Add dependency",
      "delete_confirm_warning": "This change cannot be undone.",
      "choose_type_label": "Choose validation type",
      "copy_empty_title": "No validations to copy",
      "copy_parameter_overlap": "Already added",
      "badge_error": "Blocking",
      "dependency_depth_tooltip": "This validation is already at the end of a dependency chain",
      "choose_fields_label": "Choose mandatory fields",
      "choose_action_label": "Choose the action where the validation applies",
      "badge_warning": "Warning",
      "copy_disabled_tooltip": "Add validations before you can copy them",
      "copy_no_results_description": "Try a different search to find validations to copy.",
      "copy_parameter_overlap_tooltip": "This validation already exists with the same fields",
      "copy_existing_validations": "Copy existing validations",
      "action_export": "Export",
      "add_validation_executing": "Adding validation",
      "configure_title": "Configure validation",
      "copy_validations_submit": "Copy validations",
      "copy_existing_validations_description": "Choose validations to copy to {documentType} → {action}",
      "copy_selected_tooltip": "A validation with this type and state is already selected",
      "copy_already_exists_tooltip": "This validation already exists in this action",
      "action_send_for_review": "Send for review",
      "copy_validations": "Copy existing validations",
      "delete_confirm_submit": "Yes, delete validation",
      "copy_selected": "Selected",
      "copy_one_severity_only": "Already added",
      "delete_confirm_title": "Do you wish to delete the validation?",
      "add_validation_submit": "Add validation",
      "already_added": "Already added",
      "dependency_action_disabled_tooltip": "This validation already has dependent validations below it and can't be extended further",
      "choose_rule_label": "Choose validation rule",
      "add_dependency_tooltip": "Add dependency",
      "action_approve": "Approve",
      "copy_empty_description": "There are no enabled validations on other actions for this document type.",
      "copy_one_severity_only_tooltip": "This validation can only be added once per action. Remove the existing validation to use another type",
      "badge_disabled": "Disabled",
      "choose_rule_title": "Choose validation rule",
      "action_document_received": "Document received",
      "delete_confirm_body": "The validation will be deleted and will no longer run on this action for this document type.",
      "feedback_updated": "Validation updated",
      "list_no_results_description": "We couldn't find any validations for this action. Try a different search.",
      "toast_create_success_text": "{validation} was added to {scope}.",
      "edit": "Edit",
      "maximum_age_description": "Defines how old the date can be in days from today",
      "list_search_placeholder": "Search validations",
      "toast_copy_error_title": "Validations were not copied",
      "error_description": "Prevents continuing",
      "dependency_unavailable_badge": "Can't be used as a dependency",
      "search_placeholder": "Search for validation rule",
      "type_creditor_is_not_active_title": "Active creditor",
      "dependency_no_candidates_tooltip": "No validations available to add as a dependency",
      "type_document_has_already_been_exported_title": "Document not already exported",
      "type_invoice_date_is_outside_allowed_range_description": "Checks that the invoice date is within the allowed export range",
      "dependency_dropzone_hint": "Drop here to add as dependent",
      "remove_dependency_tooltip": "Remove dependency",
      "dependency_empty_description": "We couldn't find any validations that can be selected as a dependency.",
      "type_account_is_not_active_description": "Checks that the selected account is active in the integration",
      "rule_exists_tooltip": "The rule has already been added for this action",
      "toast_dependency_remove_success_title": "Dependency removed",
      "dependency_dropzone_active_hint": "Drop here to add as dependent on this validation",
      "toast_update_error_title": "Validation was not updated",
      "type_cost_type_is_not_active_description": "Checks that the selected cost type is active in the integration",
      "feedback_title": "Validations",
      "type_payment_fields_do_not_match_creditor_defaults_description": "Checks that the document’s payment fields match the creditor’s configured payment settings",
      "type_cost_type_is_not_active_title": "Active cost type",
      "type_due_date_is_outside_allowed_range_title": "Due date within allowed range",
      "type_missing_journal_entries_description": "Checks that at least one journal entry is added before continuing",
      "type_document_is_duplicate_description": "Checks that the document is not marked as a duplicate",
      "toast_dependency_save_success_title": "Dependency updated",
      "type_creditor_is_not_active_description": "Checks that the selected creditor is active in the integration\n",
      "type_employee_is_not_active_description": "Checks that the selected employee is active in the integration",
      "type_account_is_not_active_title": "Active account",
      "type_missing_journal_entries_title": "Journal entry exist",
      "maximum_age_label": "Maximum allowed age (days)",
      "toast_delete_error_title": "Validation was not deleted",
      "dependency_unavailable_tooltip": "This validation can't be used as a dependency",
      "type_cost_type_requires_matching_ongoing_account_description": "Checks that the cost type matches the configured ongoing account in the cost group",
      "feedback_delete_dependency_error": "Remove the dependent validations first before deleting this validation.",
      "toast_delete_success_title": "Validation deleted",
      "missing_field_translation": "Missing translation for {field}",
      "type_invoice_date_is_outside_allowed_range_title": "Invoice date within allowed range",
      "type_cost_type_requires_project_description": "Checks that a project is selected when the cost type requires one",
      "toast_copy_success_title": "Validations copied",
      "type_net_amount_plus_vat_equals_total_amount_title": "Net amount plus VAT equals total amount",
      "toast_dependency_invalid_drop_title": "Dependency not allowed",
      "type_invoice_date_is_before_due_date_description": "Checks that the due date is after the invoice date",
      "no_results_description": "We couldn't find what you were looking for. Try a different search.",
      "no_results_title": "Nothing in the box!",
      "feedback_dependency_save_error": "Could not save the dependency.",
      "toast_update_success_title": "Validation updated",
      "field_locked_tooltip": "This field is already used by the {severity} validation for this rule",
      "toast_sort_error_title": "Validation order was not updated",
      "type_document_is_duplicate_title": "Document is not a duplicate",
      "type_invoice_date_is_before_due_date_title": "Due date after invoice date",
      "toast_update_success_text": "{validation} was updated for {scope}.",
      "dependency_modal_title": "Add dependency",
      "type_contra_account_is_not_active_description": "Checks that the selected contra account is active in the integration",
      "type_document_has_already_been_exported_description": "Checks that the document has not already been exported",
      "toast_dependency_save_error_title": "Dependency was not updated",
      "maximum_age_badge": "{count} days",
      "dependency_search_placeholder": "Search validations",
      "type_cost_type_requires_project_title": "Cost type requires project",
      "toast_delete_success_text": "{validation} was removed from {scope}.",
      "type_due_date_is_outside_allowed_range_description": "Checks that the due date is within the allowed export range",
      "list_no_results_title": "No matching validations",
      "empty_title": "No validations rules have been added yet",
      "no_additional_configuration": "No additional configuration is required for this rule.",
      "toast_create_success_title": "Validation added",
      "toast_dependency_save_success_text": "Dependency saved for {dependency}.",
      "toast_dependency_remove_success_text": "Dependency removed from {dependency}.",
      "type_cost_type_requires_matching_ongoing_account_title": "Cost type matches ongoing account",
      "type_net_amount_plus_vat_equals_total_amount_description": "Checks that net amount and VAT add up to the total amount",
      "toast_delete_dependency_error_title": "Validation can't be deleted",
      "feedback_deleted": "Validation deleted",
      "maximum_age_placeholder": "Enter number of days",
      "feedback_delete_error": "Could not delete the validation.",
      "feedback_sort_error": "Could not save the new validation order.",
      "toast_dependency_remove_error_title": "Dependency was not removed",
      "feedback_save_error": "Could not save the validation.",
      "toast_sort_error_text": "We couldn't save the new validation order for {scope}.",
      "dependency_descendant_tooltip": "This validation is already dependent on this one",
      "toast_create_error_title": "Validation was not added",
      "toast_copy_success_text": "{count} validation was copied to {scope}. | {count} validations were copied to {scope}.",
      "dependency_empty_title": "No matching validations",
      "type_employee_is_not_active_title": "Active employee",
      "empty_description": "Add validation rules to control what must be checked when actions are performed on documents",
      "type_contra_account_is_not_active_title": "Active contra account",
      "error_exists_tooltip": "Error validation already exists for this rule",
      "type_payment_fields_validation_failed_description": "Checks that the payment details contain a valid combination of values",
      "feedback_dependency_remove_error": "Could not remove the dependency.",
      "dependency_modal_description": "Choose the validation this depends on. This validation will only run if the selected validation passes.",
      "feedback_created": "Validation added",
      "type_payment_fields_do_not_match_creditor_defaults_title": "Payment fields match creditor payment settings",
      "update_validation_executing": "Updating validation",
      "type_required_item_fields_are_not_filled_title": "Mandatory document fields",
      "update_validation_submit": "Update validation",
      "type_required_accounting_lines_are_not_filled_description": "Checks that all mandatory fields on journal entries are filled",
      "type_required_accounting_lines_are_not_filled_title": "Mandatory journal entry fields",
      "warning_exists_tooltip": "Warning validation already exists for this rule",
      "used_by_warning": "Used by Warning validation",
      "type_project_is_not_active_title": "Active project",
      "used_by_error": "Used by Error validation",
      "type_project_is_not_active_description": "Checks that the selected project is active in the integration",
      "type_payment_fields_validation_failed_title": "Valid payment details",
      "type_required_item_fields_are_not_filled_description": "Checks that all mandatory document fields are filled",
      "warning_description": "Shows a warning but allows continuing",
      "type_project_requires_cost_type_title": "Project requires cost type",
      "type_project_requires_cost_type_description": "Checks that a cost type is selected when the project requires one",
      "disabled_description": "This validation is disabled and will not run",
      "load_error_retry": "Retry",
      "feedback_copy_error": "The validations could not be copied. Try again.",
      "load_error_description": "We couldn't load the validation setup. Try again to reload the validation rules.",
      "load_error_title": "Validations could not be loaded",
      "type_total_amount_is_not_sum_of_accounting_lines_description": "Checks that the sum of journal entry lines matches the document’s selected amount",
      "type_total_amount_is_not_sum_of_accounting_lines_title": "Journal entry lines match amount",
      "activity_log_deleted": "Validation deleted: {validationName}",
      "activity_log_created": "Validation created: {validationName}",
      "activity_log_updated": "Validation updated: {validationName}"
    },
    "widgets": {
      "actions_description": "Set which actions are available in {widget}",
      "description": "Description",
      "key_metrics_description": "Set which KPI's are shown in {widget}",
      "key_metrics": "Key metrics",
      "title": "Widgets",
      "global_settings": "Global settings",
      "widgets_visibility_description": "Activating the widget will make it possible to assign it to a role. The role determines whether a user can see the widget",
      "subtitle": "Manage widgets in your organization",
      "actions": "Actions",
      "widget_activation": "Activate widget",
      "document_fields_description": "Set which document fields are available in {widget}",
      "journal_entries_description": "Set which journal entries are available in {widget}"
    },
    "role": {
      "subtitle": "Manage roles in your organization"
    },
    "email_notifications": {
      "month_end_approaching": "Month-end approaching",
      "weekday_friday": "Friday",
      "month_end_approaching_description": "Notify about pending documents before the end of the month",
      "day_before": "{count} day before | {count} days before",
      "frequency_description": "Choose which days and times notifications are sent",
      "activate": "Enable email notifications",
      "past_due": "Past due",
      "activate_description": "Send scheduled email notifications about documents that need attention",
      "week_before": "{count} week before | {count} weeks before",
      "global": "Global settings",
      "day_after": "{count} day after | {count} days after",
      "due_date_approaching": "Due date approaching",
      "save_failed": "Email notification settings could not be saved. Your last saved settings have been restored.",
      "frequency": "Delivery schedule",
      "immediately": "Immediately",
      "types_description": "Choose which document alerts are included in the email",
      "subtitle": "Manage email notifications in your organization",
      "weekday_wednesday": "Wednesday",
      "weekday_saturday": "Saturday",
      "types": "Notification types",
      "saved": "Email notification settings saved",
      "weekday_monday": "Monday",
      "due_date_approaching_description": "Notify when a document is approaching its due date",
      "weekday_sunday": "Sunday",
      "description": "Description",
      "global_description": "Turn email notifications on or off for the organization",
      "weekday_thursday": "Thursday",
      "pending_from_last_month_description": "Notify about documents that are still pending from the previous month",
      "weekday_tuesday": "Tuesday",
      "past_due_description": "Notify when a document has passed its due date",
      "title": "Email notifications",
      "page_description": "Choose which email notifications to send and when to send them",
      "pending_from_last_month": "Pending from last month",
      "load_failed": "Email notification settings could not be loaded. Reload the page to try again.",
      "week_after": "{count} week after | {count} weeks after"
    }
  },
  "roles": {
    "columns": {
      "description": "Description",
      "name": "Name",
      "amount_of_users": "Number of users"
    },
    "not_set": "Not set",
    "roles_in_total": "{count} roles in total",
    "purchaser_description": "This role is only allowed to view their own awaiting documents + Match",
    "administrator": "Administrator",
    "approver": "Approver",
    "auditor": "Auditor",
    "approver_description": "This role is allowed to view their own awaiting documents",
    "approver_plus": "Approver Plus",
    "auditor_description": "This role is only allowed to view data (read-only user)",
    "accountant": "Bookkeeper",
    "purchaser": "Purchaser",
    "administrator_description": "This role is eligible to view and edit everything",
    "header": "Roles",
    "accountant_description": "This role is allowed everything besides user administration",
    "approver_plus_description": "This role is allowed to view their own awaiting documents and edit journal entries"
  },
  "search_and_filter": {
    "search_and_filter": "Search and filter for",
    "companies": "Companies",
    "document_types": "Document types",
    "users": "Users",
    "active_filters": "Active filters",
    "work_status": "Work status",
    "no_results": "Press Enter to search...",
    "or": "or",
    "recent_searches": "Recent searches"
  },
  "re": {
    "back": "Return to login"
  },
  "shortcuts": {
    "focus_item_list": "Select first document",
    "show_comments": "Show comments",
    "move_to_exported": "Move to exported",
    "search_placeholder": "Search for shortcuts",
    "pagination_next": "Go to next page",
    "no_results": "No shortcuts found",
    "keyboard_shortcuts": "Keyboard Shortcuts",
    "move_to_another_document": "Move to another document",
    "create_journal_entry": "Create new journal entry",
    "remind_assignees": "Remind assignees",
    "deselect_items": "Deselect all document | Deselect all documents",
    "copy_field_value_above": "Copy field value above",
    "go_to_last_row": "Go to last row",
    "export_documents": "Export document | Export documents",
    "next_document": "Next document",
    "document_view": "Document view",
    "previous_page": "Previous page",
    "select_mode": "Select mode",
    "place_on_hold": "Place on hold",
    "select_document": "Select document",
    "begin_approval": "Begin approval",
    "primary_action": "Primary action",
    "search_and_filter": "Search and filter",
    "previous_document": "Previous document",
    "move_to_another_company": "Move to another company",
    "jump_to_first_field": "Jump to first field",
    "next_field": "Next field",
    "go_to_first_row": "Go to first row",
    "navigate_up": "Navigate up",
    "expanded_view": "Expanded view",
    "standard_view": "Standard view",
    "copy_row_below": "Copy row below",
    "show_activity_log": "Show activity log",
    "jump_to_first_journal_entry": "Jump to the first journal entry",
    "no_results_title": "We couldn’t find the shortcut you were searching for",
    "switch_to_approved": "Approved",
    "shortcuts_for": "Keyboard shortcuts for {page}",
    "back_to_document_lists": "Back to document lists",
    "expand_view": "Expand",
    "navigate_down": "Navigate down",
    "pagination_prev": "Go to next page",
    "multi_select_document": "Multi-select document",
    "show_attachments": "Show attachments",
    "next_page": "Next page",
    "select_all_items": "Select all documents",
    "export_to_excel": "Export to Excel",
    "focus_next_item": "Select next document",
    "open_document": "Open document",
    "copy_field_value_below": "Copy field value below",
    "command_palette_search": "Command palette search",
    "download_as_xml": "Download as XML",
    "see_all_shortcuts": "See all shortcuts",
    "fit_to_width": "Fit to width",
    "process_documents": "Process documents",
    "compact_view": "Compact view",
    "download_as_pdf": "Download as PDF",
    "switch_panel": "Switch panel",
    "previous_field": "Previous field",
    "focus_prev_item": "Select previous document",
    "move_mode": "Move mode",
    "review_documents": "Review document | Review documents",
    "copy_row_above": "Copy row above",
    "open_batchflow_wiki": "Open Batchflow Wiki",
    "copy_invoice_link": "Copy invoice link",
    "preview_document": "Preview document",
    "move_freely_journal_entries": "Move freely around in the journal entries",
    "secondary_action": "Secondary action",
    "context": {
      "invoice_viewer": "Invoice viewer",
      "search": "Search",
      "change_widget": "Change widget",
      "actions": "Actions",
      "misc": "Misc",
      "navigation": "Navigation",
      "journal_entries": "Journal entries",
      "download": "Download",
      "move_to": "Move to",
      "layout": "Layout",
      "document_list": "Document list",
      "field_navigation": "Field navigation"
    },
    "no_results_description": "Check spelling or try another search",
    "zoom_in": "Zoom in",
    "keys": {
      "spacebar": "Spacebar",
      "page_down": "Page Down",
      "shift": "Shift",
      "ctrl": "Ctrl",
      "page_up": "Page Up",
      "home": "Home",
      "arrows": "Arrows",
      "alt": "Alt",
      "end": "End",
      "tab": "Tab",
      "cmd": "Cmd",
      "minus": "Minus",
      "enter": "Enter",
      "plus": "Plus"
    },
    "switch_to_on-hold": "On hold",
    "zoom_out": "Zoom out",
    "upload_documents": "Upload document",
    "switch_to_my-archive": "My archive",
    "switch_to_declined": "Declined",
    "switch_to_inbox": "My inbox",
    "view_documents": "View Documents",
    "switch_to_under-review": "Under review",
    "switch_to_new-documents": "New documents",
    "toggle_invoice_format": "Toggle invoice format",
    "tertiary_action": "Tertiary action",
    "switch_to_export-errors": "Export errors",
    "get_help": "Get help",
    "open_shortcuts": "Open shortcuts",
    "move_to_archived": "Move to Archived"
  },
  "user": {
    "fields": {
      "email": "Email",
      "language": "Language",
      "phonenumber": "Phone number",
      "displayname": "Name"
    },
    "confirm": {
      "remove_from_company_text_is_last": "Removing them from the company will revoke their access Batchflow and they will no longer be able to log in.",
      "remove_from_company_text_2": "This action requires you to find a replacement for their documents.",
      "remove_from_company_title": "Are you sure you wish to remove {user} from {company}?",
      "deactivate_user_text": "This will remove the user from all listed companies they're part of in the organization. ",
      "deactivate_user_title": "Are you sure you want to deactivate the user {user}?",
      "deactivate_user_text2": "You'll need to choose a replacement to take over in all flows, as delegate, and their documents will automatically be transferred to the replacement.",
      "remove_from_company_bottom": "This action cannot be undone and requires a new invitation to be sent to them.",
      "remove_from_company_text": "Removing them from the company will revoke their access to everything related to the company."
    },
    "work_status": {
      "out_of_office": "Out of office",
      "working": "Working",
      "out_of_office_in_days": "User is going out of office in {count} day | User is going out of office in {count} days",
      "select_user": "Select delegate user",
      "out_of_office_until": "User is out of office until {date}",
      "user_is_out_of_office": "User is out of office",
      "only_user": "You're the only user"
    },
    "activate": {
      "confirm_text_2": "This action will give them access to Batchflow",
      "yes_activate": "Yes, activate",
      "confirm_text": "Are you sure you want to activate the user"
    },
    "deactivate": {
      "confirm_text_2": "This action will lock them out of Batchflow",
      "confirm_text": "Are you sure you want to deactivate",
      "yes_deactivate": "Yes, deactivate"
    },
    "remove_from_company": {
      "yes_find_replacement": "Yes, find a replacement"
    },
    "work": {
      "you_are_only_user": "You cannot choose a delegate as you’re the only employee in company"
    },
    "tooltip": {
      "approval_limit_title": "Multiple approval limits",
      "approval_view_all": "View all",
      "approval_more_limits": "+{count} limit | +{count} limits",
      "approval_more_companies": "+{count} more company | +{count} more companies"
    }
  },
  "sidebar": {
    "wiki": "Wiki",
    "inbound": "Inbound / Outbound",
    "documents": "Documents",
    "archive": "Archive",
    "search": "Search",
    "shortcuts": "Shortcuts",
    "settings": "Settings"
  },
  "users": {
    "out_of_office": {
      "user_is_out_of_office": "User is Out of office",
      "users_are_out_of_office": "{count} user is Out of office | {count} users are Out of office",
      "users_are_delegates": "{count} user is delegate | {count} users are delegates"
    },
    "deactivated": "Deactivated",
    "columns": {
      "employee": "Name",
      "usertype": "Role",
      "mail": "Email",
      "status": "Status",
      "companies": "Companies"
    },
    "inactive": "Deactivated",
    "active": "Active",
    "search_empty": {
      "header": "Nothing in the box!",
      "subheader": "We couldn't find what you were looking for. Try a different search."
    },
    "search_and_filter": "Search and filter for Name, Email, Companies, or Status"
  },
  "time": {
    "years": "{count} year | {count} years",
    "hours": "{count} hour | {count} hours",
    "days": "{count} day | {count} days",
    "months": "{count} month | {count} months",
    "minutes": "{count} minute | {count} minutes",
    "seconds": "{count} second | {count} seconds"
  },
  "system": {
    "username": "Batchflow",
    "automation_username": "Batchflow automations"
  },
  "sign": {
    "out": "Log out"
  },
  "sorting": {
    "descending": "Descending",
    "category": "Categories",
    "apply": "Apply",
    "ascending": "Ascending"
  },
  "widget": {
    "buttons": {
      "export_selected_documents": "Export selected document | Export selected documents",
      "export_documents_executing": "Exporting documents",
      "upload_documents": "Upload document",
      "move_documents": "Move document | Move documents",
      "refresh_executing": "Updating",
      "remind_assignees_executing": "Reminding assignees",
      "process_selected_documents": "Process selected document | Process selected documents",
      "review_documents_executing": "Reviewing documents",
      "remind_item_assignees_executing": "Reminding",
      "review_documents": "Review documents",
      "view_selected_documents": "View selected documents",
      "review_selected_documents": "Review selected document | Review selected documents",
      "refresh": "Update",
      "remind_selected_assignees": "Remind selected assignees",
      "process_selected_documents_executing": "Processing selected documents",
      "decline_item_executing": "Declining document",
      "export_selected_documents_executing": "Exporting selected documents",
      "remind_assignees": "Remind assignees",
      "process_documents_executing": "Processing documents",
      "remind_selected_assignees_executing": "Reminding selected assignees",
      "export_excel_selected": "Export selected to Excel",
      "process_documents": "Process documents",
      "review_selected_documents_executing": "Reviewing selected documents",
      "export_documents": "Export documents",
      "move_documents_executing": "Moving documents",
      "export_excel": "Export to Excel "
    },
    "deleted": "Deleted",
    "archive": {
      "deleted_warning_button": "Deleted documents are removed after 90 days"
    },
    "description": {
      "my-archive": "Documents which the user has previously reviewed (Personal archive)",
      "exported": "Documents which have been exported",
      "declined": "Documents which have been declined",
      "export-errors": "Documents which have failed during export and where errors can be handled",
      "under-review": "Documents which have been sent out for approval (Multiple inbox overview)",
      "deleted": "Documents which have been deleted",
      "archived": "Documents which have been archived",
      "on-hold": "Documents which have been set on hold for further processing",
      "inbox": "Documents which are ready to be approved (Personal inbox)",
      "new-documents": "Documents which have been received and are ready to be processed",
      "approved": "Documents which have been approved and are ready for export",
      "my-on-hold": "Documents which have been put on hold for further processing by the user (Personal on hold)",
      "outbound": "Documents which are being exported",
      "departments": "Documents from My inbox until department filtering is available"
    },
    "assignee": "assignee | assignees",
    "my-on-hold": "My on hold",
    "exported": "Exported",
    "outbound": "Outbound",
    "approved": "Approved",
    "my-archive": "My archive",
    "on-hold": "On hold",
    "declined": "Declined",
    "export-errors": "Export errors",
    "inbox": "My inbox",
    "new-documents": "New documents",
    "archived": "Archived",
    "under-review": "Under review",
    "departments": "Departments",
    "all-documents": "All documents"
  },
  "validation": {
    "flow": {
      "decliners_cant_exceed_users": "Declines can't exceed the number of users",
      "approvers_cant_exceed_users": "Approvals can't exceed the number of users",
      "approvers_cant_be_empty": "At least one approver is needed"
    },
    "fields": {
      "bic_swift_invalid": "Format: 6 letters, 2 alphanumeric characters, and optional 3 alphanumeric characters\n",
      "confirmed_fields": "{fields} do not match",
      "min": "{field} should be a minimum of {length} characters",
      "numeric": "{field} can only contain numbers",
      "max_value": "{field} cannot be more than {length}",
      "same_email_as_current": "Provided email is the same as your current",
      "password": "The password doesn't meet our security standards",
      "iban_invalid_format": "Format: 2 uppercase letters, then 13-31 alphanumeric characters",
      "iban_invalid": "The checksum digits are incorrect, indicating that the IBAN is not valid",
      "max": "{field} should be a maximum of {length} characters",
      "cant_assign_delegated_user_loop": "User is delegate for this user",
      "password_incorrect": "Password is not correct",
      "required": "{field} is required",
      "email_already_used": "Email is already in use, please provide a unique email",
      "min_value": "{field} cannot be less than {length}",
      "max_length": "Phone number cannot exceed 15 digits.",
      "invalid_payment_id": "{fieldName} for Type {typeFieldName} should be {minNumber}-{maxNumber} numbers",
      "url": "{field} is not a valid URL",
      "invalid_length": "{fieldName} should be {minNumber}-{maxNumber} numbers",
      "confirmed": "Passwords does not match",
      "email": "Not a valid email, please try again",
      "invalid_field": "Invalid field",
      "invalid_non_zero": "Value must not be zero"
    },
    "error": {
      "could_not_export_item": "The document cannot be exported until the validation issues have been resolved.",
      "could_not_assign_template": "The flow template could not be assigned.",
      "could_not_load_flow_templates": "The flow templates could not be loaded.",
      "could_not_approve_item": "The document cannot be approved until the validation issues have been resolved. ",
      "could_not_send_for_review": "The document cannot be sent for review until the validation issues have been resolved. "
    },
    "default": "{field} is invalid"
  },
  "widgets": {
    "columns": {
      "status": "Status",
      "widget": "Widget",
      "description": "Description"
    },
    "inactive": "Deactivated",
    "deactivated": "Deactivated",
    "active": "Active"
  },
  "websockets": {
    "users_on_field": "Is active in this field",
    "users_in_room": "Is active on this document"
  },
  "wiki": {
    "header": {
      "link": "Open in a new window",
      "title": "Batchflow Wiki"
    }
  },
  "work_status": {
    "out_of_office": "Out of office"
  },
  "xml_file": {
    "download": {
      "message": "This might take a few moments...",
      "title": "Getting your XML ready",
      "error_message": "The XML file could not be downloaded. Try again.",
      "error_title": "XML download failed"
    }
  },
  "workstatus": {
    "timeframe": "Timeframe",
    "calendar_message": "Please select a timeframe for your work status",
    "apply_delegate": "Apply delegate",
    "return_to_office": "Return to office",
    "update": "Update",
    "apply_indefinitely": "Apply indefinitely",
    "edit_message": "Please select which status fits your current work status",
    "apply_timeframe": "Apply time frame",
    "status_as_working": "Set work status as working",
    "edit_out_of_office": "Edit out of office",
    "change_status": "Change status",
    "please_select_time": "Please select a timeframe",
    "find_delegate_message": "Please select someone to be your delegate in ",
    "edit_your_out_of_office": "Edit your out of office",
    "start_end_day": "Pick an end day",
    "select_delegate": "Please select a delegate for the following company | Please select a delegate for the following companies",
    "find_delegate": "Find a delegate",
    "no_delegate_title": "No delegate available",
    "no_delegate_message": "You cannot set yourself out of office as you are the only employee of "
  },
  "activity_log": {
    "projects": {
      "no_cost_type_name": "No cost type name",
      "no_project_number": "No project number"
    },
    "employees": {
      "no_employee_name": "No employee name"
    }
  },
  "activity": {
    "flow": {
      "auto_decline_1": "Document declined because the approval flow couldn’t reach a final decision.",
      "auto_decline_2": "Decline reason: “No final decision could be reached in the approval flow”"
    },
    "customfield": "Custom field"
  },
  "common": {
    "unknown_company": "Unknown company",
    "unknown_email": "Unknown email",
    "unknown_user": "Unknown user",
    "creditor": "Creditor"
  },
  "column": {
    "reset_columns": "Reset columns"
  },
  "export": {
    "errors": {
      "no_error_found": "No error found"
    }
  },
  "top_bar": {
    "get_help": "Get help"
  },
  "errors": {
    "something_went_wrong": "Something went wrong"
  },
  "integration": {
    "name": {
      "unknown": "Unknown integration"
    }
  },
  "works": {
    "status": {
      "you_are_only_user": "You’re the only user"
    }
  },
  "button": {
    "desktop_app_warning": {
      "stay_on_mobile": "Stay on mobile",
      "open_desktop_version": "Open desktop version"
    }
  },
  "journal_profiles": {
    "columns": {
      "creditor": "creditors",
      "number_of_lines": "Entries",
      "name": "Name",
      "description": "description"
    },
    "form": {
      "add_a_creditors": "Add a creditor",
      "creditor": "Creditor",
      "added_creditors": "Linked creditors",
      "amount_fields_subtitle": "Choose whether the Amount fields should be left empty or pre-filled when the template is applied",
      "delete_template_confirmation": "The template will be removed from use within Batchflow",
      "delete_template": "Delete template",
      "delete_template_title": "Do you want to delete this template?",
      "delete_template_confirmation_warning": "This action cannot be undone",
      "amount_fields": "Amount fields",
      "empty_creditors_linked_yet": "No creditors have been linked yet",
      "description": "Description",
      "search_for_creditors_to_link": "Search for creditors above to link them to this template",
      "selected_icon": "Selected icon",
      "no_creditors_linked_yet": "No creditors linked yet",
      "icon": "Icon",
      "template_icon": "Template icon",
      "keep_amounts_empty_description": "When the template is applied, Amount fields remain empty",
      "link_creditors_description": "Link creditors to this template to show it as a favorite by default when the creditor is selected on a document",
      "select_for_creditors": "Select a creditor",
      "unlink": "Unlink creditor",
      "manage_creditor_links": "Manage creditors",
      "icon_subtitle": "Choose an icon for this template",
      "icon_subtitle_template": "Choose an icon to represent this template",
      "search_for_creditors": "Search for creditors",
      "empty_link_creditors_description": "Link creditors to this template to show it as a favorite when browsing templates for documents with those creditors selected",
      "save_amounts": "Pre-fill amounts",
      "search_icons": "Search icons",
      "no_icons_found": "Couldn’t find the icon you were looking for",
      "keep_amounts_empty": "Leave amounts empty",
      "linked_creditors_subtitle": "This template is shown as a favorite when a linked creditor is selected on a document",
      "name": "Name",
      "link_creditors": "Link creditors",
      "no_icons_found_spelling": "Check spelling or try another search",
      "linked_creditors": "Linked creditors",
      "template_details": "Template details",
      "save_amounts_description": "When the template is applied, Amount fields are filled with the saved values",
      "description_subtitle": "Optional note to help others choose this template",
      "name_subtitle": "Used in template lists and when applying this template",
      "template_details_subtitle": "Set the name and description for this template"
    },
    "search_and_filter": "Search and filter for Name, Description, and Creditor",
    "template": {
      "link_creditors": "Linked creditor",
      "link_creditors_description": "Linking a creditor to a template allows users to view the journal entry template when working from the documents page."
    },
    "buttons": {
      "create_journal_entry_template": "Create journal entry template"
    },
    "notifications": {
      "template_deleted_subtitle": "You have permanently deleted the template ",
      "template_deleted": "Template was deleted",
      "template_saved": "Template was saved",
      "template_saved_subtitle": "You have successfully saved changes to:",
      "template_created_subtitle": "You have successfully created the template:"
    }
  },
  "creditor": {
    "not": {
      "found": "Select a creditor to browse templates"
    }
  },
  "template": {
    "name": {
      "placeholder": "Please select a template to overwrite"
    }
  },
  "departments": {
    "buttons": {
      "create_new": "Create new department",
      "update": "Update department"
    },
    "description_optional": "Description (optional)",
    "edit_title": "Edit department",
    "columns": {
      "description": "Description",
      "name": "Department name",
      "members": "Number of members"
    },
    "search_and_filter": "Search & filter for Department name or description",
    "members": "Members",
    "role": {
      "member": "Member",
      "supervisor_description": "Supervisors will be able to view the department's active and archived documents in a separate widget.",
      "member_description": "Members will be shown in the department, but will not be able to view active or archived documents",
      "supervisor": "Supervisor"
    },
    "search_empty": {
      "subheader": "All of your departments will be shown here once they've been created...",
      "header": "Couldn't find any departments"
    },
    "search_members": "Search for a name or an email",
    "details": "Department details",
    "name_placeholder": "Please provide a department name",
    "empty_members": "No members have been added yet",
    "description_placeholder": "Describe the department"
  }
};